
import confetti from 'canvas-confetti';
import  React,{ useEffect, useState } from "react";
import {useStateContext} from '../context/StateContext';
import lang from "../JSON-FILES/lang.json"
import Swal from "sweetalert2"
import { v4 as uuidv4, v4 } from 'uuid';
import { logDoc, deviceNonConformityDoc } from '../components/gestioneDatabase/Docs';
import { urlFor } from './client';
import deadlines from '../components/Deadlines';
import { toast } from 'react-hot-toast';
import imageCompression from 'browser-image-compression'; // Import image compression library
import { HiddenOfferData } from '../components/offerComponents/HiddenOfferData';
import { postingEmail } from '../components/NodeMailer';
import nonConformity from '../sanity_ecommerce/schemas/nonConformity';

const P = "utils"
/**
 * #core
 * @param {{now: Date, docType: string, inputValue: string, okFn: (name: string) => void}}
 * @returns {Promise<void>}
 * @description Prompt user to enter a name for a given docType, and
 *              call okFn with the entered name if user clicks OK.
 */
export const addNameSwal = async({now = Date.now(), docType, inputValue = ``, okFn = () => {}}) => {
    const { value: name } = await Swal.fire({
        title: `NOME ${docType}`,
        input: "text",
        inputValue,
        showCancelButton: true,
        inputValidator: (value) => {
            if (!value) {
            return "Inserire un nome";
            }
        }
        });
        if (name) {
        okFn(name)
        }
    }
/**
 * Capitalize the first letter of a given string.
 * #core
 * @param {string} str string to capitalize
 * @returns {string} capitalized string
 */
export const capitalizeFirst = (str) => {
  if (!str) return '';
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
}
/**
 * Return an array of unique register IDs from an array of offerFields.
 * If the array contains at least one sign (i.e., an object with an "isSign" property equal to true),
 * then the hardcoded string "weduwheiudghyegwuyjke88363ghdloiejdf87" is included in the returned array.
 * #offers
 * @param {Array<Object>} offerFields array of offer fields
 * @returns {Array<string>} array of unique register IDs
 */
export const registerIdsFromOfferFields = (offerFields = []) => {
  if(!Array.isArray(offerFields)) return []
  const uniqueRegisters = !Array.isArray(offerFields) ? [] : unique("registerId", offerFields)?.map?.((x)=>x?.registerId)
  const isThereSigns = offerFields?.find?.((x)=>x?.isSign)

  if(isThereSigns) return [...uniqueRegisters, "weduwheiudghyegwuyjke88363ghdloiejdf87"]
  return unique("registerId", offerFields)?.map?.((x)=>x?.registerId)
}
  /**
   * @function
   * @param {object} deviceFieldValue - The field with the value to be returned
   * @param {object} registerTemplate - The register template from which the dropdown values are taken
   * @param {boolean} [showValue=false] - If true, the value of the field list is returned
   * @param {boolean} [showTemplate=false] - If true, the whole field list object is returned
   * @returns {string|object} The value of the field list corresponding to the device field value, or the device field value itself if no match is found
   */
export const templateDeviceValue = (deviceFieldValue, registerTemplate, showValue=false, showTemplate=false) => {

  const valueId = deviceFieldValue?._id

  const fields = !Array.isArray(registerTemplate?.fields) ? [] : registerTemplate?.fields?.length > 0 ? registerTemplate?.fields : []
  const locations = !Array.isArray(registerTemplate?.locations) ? [] : registerTemplate?.locations?.length > 0 ? registerTemplate?.locations : []
  const dataModules = [fields, locations].flat().filter?.((x)=>x?.fieldType == "dropdown")
  const lists = dataModules.map?.((y)=> y?.lists).flat()
  const fieldLists = !Array.isArray(lists) ? [] : lists.map?.((z)=> z?.fieldList).flat()

  const findFieldList = fieldLists?.find?.((l)=>l?._id == valueId)
  
  if(findFieldList) return findFieldList?.label
  if(findFieldList && showValue ) return findFieldList?.value
  if(findFieldList && showTemplate ) {
    console.log("returned")
    return (findFieldList)}
  return deviceFieldValue?.value
}

  /**
   * 
   * @function
   * @param {object} reference - The object containing the _ref field to be matched
   * @param {array} referenceLocationArray - The array of objects containing the _id field to be matched
   * @returns The matched object from the referenceLocationArray if the _ref from the reference matches the _id of an object in the array
   * 
   * This function takes a reference object and an array of objects and returns the object from the array that matches the _ref field of the reference.
   * #databaseManagement
   * The function is used to expand a reference to a document in an array to the actual document inside the array.
   * 
   * The function is used in the following components:
   * - DevicePin.jsx
   * - Registers.jsx
   * - Wheel.jsx
   */
export const expandReference = (reference, referenceLocationArray) => {
  //console.log("expandReference:", reference)
  let _ref = reference?._ref
  //console.log("_ref:", _ref)
  //console.log("referenceLocationArray:", referenceLocationArray)

  const matchedDevice = () => !Array.isArray(referenceLocationArray) ? undefined : referenceLocationArray?.find?.((x)=> x._id ==_ref)

  //console.log("matchedDevice:", matchedDevice())

  return matchedDevice()

}

/**
 * Searches through device field arrays and returns matching field values with IDs
 * #deviceFields
 * @param {string} fieldId The id of the field for which I want to find the value
 * @param {array} fieldsArray The array of device field arrays to search through
 * @param {object} templateDevice The template device from which the device field value is taken
 * @param {boolean} [monthYear=false] If true, the value of the field list is returned as "month/year" format
 * @returns {string|object} The value of the field list related to the device field value, or the device field value itself if no match is found
 */
export const matchTemplateFieldWithValue = (fieldId, fieldsArray, templateDevice, monthYear) => {  

  //console.log("matchTemplateField")
  
  if(!fieldsArray){
    //console.log("array non trovato")
    return({value:""})} else {
      //console.log("array:",fieldsArray)
    }

  const match = () => !Array.isArray(fieldsArray) ? undefined : fieldsArray?.find?.((x)=>{
      return x?.templateField?._ref == fieldId
  
   })

   const values = match()?.values
   //console.log("match:", values.length)

   
  if(values?.length==0) {
    //console.log("trovato = 0", values)
    return {value:""}}

  if(values?.length==1) {
    //as I cannot define isDate in any other waty at the moment, I excluded these fields
    if (match()?.templateField?._ref == "5710d994-8bc9-4981-a5af-94a535d27bbd") return (values?.[0])
    if (match()?.templateField?._ref == "f0fd3f90-ef02-4dae-a4df-dfff44aba409") return (values?.[0])
      
    const templateValue = templateDeviceValue(values?.[0], templateDevice)

   // #deadlines
   // This algorythm helps settijng up the correct deadlines
    const isDate = (Number(templateValue) > 1970 &&  Number(templateValue) < 2200) ? true : false 
    const obj = values?.[0]?.dateObject
    const isYearANumber = Number(templateValue) ? Number(templateValue) : undefined;
/*     if(templateDevice) {
      console.log("trovato = 1", {value: values?.[0], templateDevice, templateValue, fieldsArray, match: match()})
    }
    */
    if(monthYear){
      if(obj){
        if(obj?.year && !obj?.month) return ({value:` 1/${obj?.year}`, dateObject: {year: obj?.year, month: 1},})
        //console.log("djnskjndskjdn", values?.[0], templateValue, match())
        return ({value: !obj?.year ? undefined : `${obj?.month ? obj?.month : 1}/${obj?.year}`, dateObject: obj})
      }
      if(!obj & isDate) {
    
        return(
        {
          value: !isYearANumber ? undefined : `1/${templateValue}`, 
          dateObject: !isYearANumber ? undefined : {month:1, year: Number(templateValue)}}
      )}
     
      //if(obj) 
      //
    }
    return {value: templateValue}
  }
  
  if(values?.length>1) {
    
    const printedValues = values.map?.((value)=>" "+value?.value)
    //console.log("more than one", printedValues ) 
    // old return printedValues?.toString()
    return ({value:printedValues?.toString()})
  }

  /*
  if(match()?.value) {
   //console.log("matched:",match().value)
  return match().value }
*/
}


/**
 * A function that compares two objects based on their label property and returns a numerical value 
 * indicating the result of the comparison.
 * 
 * @param {Object} a - the first object to compare
 * @param {Object} b - the second object to compare
 * @returns {number} -1 if a.label < b.label, 1 if a.label > b.label, 0 if a.label == b.label
 */
export const sortLabelCompare = ( a, b ) => {
  if ( a?.label < b?.label ){
    return -1;
  }
  if ( a?.label > b?.label ){
    return 1;
  }
  return 0;
}



/**
 * Returns the initial value of a device field based on the current device and the field properties.
 * If the field is a dropdown and isMulti is true, it returns an array of values.
 * If the field is a dropdown and isMulti is false, it returns a single value with the label and value properties.
 * If the field is a boolean, it returns a boolean value.
 * If the field is any other type, it returns a string value.
 * #core
 * @param {Object} currentDevice - the device to which the field belongs
 * @param {Object} field - the field object containing the properties of the field
 * @param {Array} deviceFields - the array of device fields
 * @param {Object} currentTemplate - the register template of the device
 * @returns {Object|string|boolean|Array} - the initial value of the field
 */
export const initialValue = (currentDevice, field, deviceFields, currentTemplate) => { 
  if (currentDevice?._id){
      //const fieldsArray = [...currentDevice?.locations,...currentDevice?.fields]
      //console.log("fieldsaaray",fieldsArray)
      //console.log("CurrentDevice",currentDevice?.locations)
      //console.log("Item",field)
      //console.log ("currentTemplate", currentTemplate.fields)
      let matchString = matchTemplateFieldWithValue(field?._id, deviceFields, currentTemplate)?.value
      //console.log("match", match)
      const match = !Array.isArray(deviceFields) ? undefined : deviceFields?.find?.((x)=>x?.templateField?._ref===field?._id)
      //console.log("matchXXX", match)

      if (match?.values?.length == 1 && !field?.isMulti && field?.fieldType=="dropdown"){
          const templateValue = templateDeviceValue(match?.values?.[0], currentTemplate, false, true)
          //console.log("match = 1", match?.values?.[0], templateValue )
          return({...match?.values?.[0], label: matchString, value: matchString })
          
      }  
     else if (match?.values?.length > 0 && field?.isMulti && field?.fieldType=="dropdown"){
          //console.log("match = 1 Multi", match, item.label)
          return([...match?.values]) 
      } 
      else if (field?.fieldType=="boolean") {
          //console.log("boolean", matchString, field.label)
          return matchString ? true : false 
      }
      else {
          //console.log("default", matchString, item.label)
          return matchString 
      }

  }
  return undefined

}
    /**
     * designed to return true only if every item in the targetArray is present in the sourceArray, 
     * using optional keys (sourceKey and targetKey) if the arrays contain objects.
     * if both arrays are empty returns false
     *  #showHideOffer
     * @param {*} param0 
     * @returns 
     */
     export const allArrayDataInTargetArray = ({ sourceArray=[], sourceKey, targetArray=[], targetKey }) => {
        const isObject = (val) => val !== null && typeof val === 'object';

        // Validate source array structure
        if (sourceKey) {
          const invalidSource = sourceArray?.find?.(item => !isObject(item) || !(sourceKey in item));
          if (invalidSource) {
            throw new Error(`Invalid item in sourceArray: Expected object with key '${sourceKey}', got: ${JSON.stringify(invalidSource)}`);
          }
        } else {
          const invalidSource = sourceArray?.find?.(item => isObject(item));
          if (invalidSource) {
            throw new Error(`Invalid item in sourceArray: Expected primitive, got object: ${JSON.stringify(invalidSource)}`);
          }
        }

        // Validate target array structure
        if (targetKey) {
          const invalidTarget = targetArray?.find?.(item => !isObject(item) || !(targetKey in item));
          if (invalidTarget) {
            throw new Error(`Invalid item in targetArray: Expected object with key '${targetKey}', got: ${JSON.stringify(invalidTarget)}`);
          }
        } else {
          const invalidTarget = targetArray?.find?.(item => isObject(item));
          if (invalidTarget) {
            throw new Error(`Invalid item in targetArray: Expected primitive, got object: ${JSON.stringify(invalidTarget)}`);
          }
        }
        if(sourceArray?.length == 0 && targetArray?.length == 0) return false
        if (!sourceArray?.length || !targetArray?.length) return false;
        // Proceed with main logic
        const sourceArraySet = new Set(
          sourceArray?.map?.(obj => (sourceKey ? obj[sourceKey] : obj))
        );

        return targetArray?.every?.(obj => sourceArraySet?.has(targetKey ? obj[targetKey] : obj));
      };

/*************  ✨ Windsurf Command ⭐  *************/
/**
 * Function to check if a field should be visible or not based on the current device and device fields
 * #deviceFields
 * @param {Object} item - The template field object
 * @param {Object} currentDevice - The current device object
 * @param {Array} deviceFields - The array of device fields
 * @returns {Boolean} True if the field should be visible, false if not
 */
/*******  e8cc556f-1b8b-49be-8751-e3ec742b56d3  *******/
export const fieldVisibleByDevice = (item, currentDevice, deviceFields) => {
  const {devices, devicesExclude, deviceProperties, propertiesExclude} = item 
  //console.log("cmsdlkcmsdlkcmskc", {item})
  const locations = !currentDevice?.locations ? []: currentDevice?.locations
  const dates = !currentDevice?.dates ? []: currentDevice?.dates
  const fields = !currentDevice?.fields ? []: currentDevice?.fields
  const allProperties = [...fields, ...locations, ...dates ]
  
  const currentDeviceId = currentDevice._id

//================DEVICE & NO PROPERTIES========================== 
  if(item?.status == "ARCHIVIATO") return false
  if(devices && (deviceProperties?.length<1|| !deviceProperties)){

     if(devices.length>0){
  
      const result = devices.some?.(obj=> obj._ref === currentDeviceId)
      
      if(result){
        if(!devicesExclude) return true
        if(devicesExclude) return false
      }
      if(!result){
        if(!devicesExclude) return false
        if(devicesExclude) return true
      }
       return false
     
    }
     return true
    
  }
   //================PROPERTIES & NO DEVICES==========================
   
   if(devices?.length<=0 && deviceProperties ){
    
    if(deviceProperties.length>0){
      
     const result = deviceProperties.some?.((obj)=>{ 
      
      return deviceFields.some?.(x=> obj?._ref == x?.values?.[0]?._id) 
    })
    //console.log("testing now", deviceFields)
    //console.log("device Properties", deviceProperties)
     
     if(result){
       if(!devicesExclude) return true
       if(devicesExclude) return false
     }
     if(!result){
       if(!devicesExclude) return false
       if(devicesExclude) return true
     }
      return false
    
   }
    return true
   
 }

 // Options with both properties and devices
 // deviceProperties?.length>0 && deviceProperties?.length>0

  return true
}


/**
 * 
 * @param {*} item needs to include the following fields:lists or value.
 * it is designed to work with _type dataModule
 * #deviceFields
 * @param {*} currentDevice the device to compare the lists with
 * @returns a list of options for the dropdown menu
 */


export const listOptions = (item={}, currentDevice) => {
  
  const {lists, value} = item
  const listsArray = lists?.filter((x)=>x?.status!== "ARCHIVIATO")
  //console.log("Current Device" , currentDevice)
  //console.log("Item ej3uje3iej" , item)
  if(!Array.isArray(listsArray)) return []

  if( listsArray?.length>1){
    //console.log("DEVICE DEP && LISTS")
    
     
      //console.log("DEVICE DEP && LISTS > 1")     
        
      const list = () => {    
          //console.log("In Const", lists)
          let array = []
          listsArray?.map?.((obj)=>{
              const {devices,_ref,_key, fieldList } = obj
             // console.log("obj:",obj )
              const match = devices?.findIndex((device)=>{
                  //console.log("obj ref:",device._ref, "curr dev id:",currentDevice._id )
                  return device?._ref === currentDevice?._id
              })
              //console.log("matched:",match)
              //if(currentDevice._id==item.)
              const key = _key
              if(match>-1){    
                  array = fieldList 
              } 
              
              //return array
          }
          )
          //console.log("item matched:",array)
          return array
      }

      return list()   
  }
  
  else if(listsArray?.length == 1){
      let array = listsArray?.[0]?.fieldList
      return array }
  else if(value){
      //setVisible(false)
      let array = [{label: value}]
      return array}
  else {
    return ["LISTA NON TROVATA, CONTROLLARE ASSEGNAZIONE LISTE"]
  }
  }



/**
 * This function takes a register object and returns a string
 * that combines the register's label and name.
 * If the register does not have a name, it returns the label.
 * #registers
 * @param {Object} register - the register object
 * @returns {String} - the combined label and name
 */
  export const registerLabelAndName = (register) => {
        if(register?.registerName) {return `${register?.label} ${register?.registerName}`}
        return register?.label
  }
  
/**
 * This function takes an array of strings and returns a new array
 * where each string is converted into an object with a label
 * and value property.
 * #core #deviceFields
 * @param {Array<string>} array - the array of strings to convert
 * @returns {Array<{label:string, value:string}>} - the new array with label and value properties
 */
export const listToLabelValue =(array=[])=>{
  
  let newArray = []
   array?.map?.((item)=>{ newArray = [...newArray,  {label:item}]
  })

  return newArray
  
}



/**
 * Takes an array of objects and adds a label and value property
 * to each object by looking up the value of the given field.
 * #core #deviceFields
 * @param {string} field - the field to look up the value for
 * @param {array} array - the array of objects to add the label and value properties to
 * @returns {array} - the new array with label and value properties
 */
export const addValueAndValueForDropdown = (field, array) => 
  array?.map?.((list)=>({...list, label:list[field], value:list[field]}))

export const addValueForDropdown = (clientsArray=[]) =>{
  let newArrayClients = []
  clientsArray?.length > 0 && clientsArray
      ?.map?.((item) => {
        const key = item?.key

          newArrayClients = [
             ...newArrayClients, {
                  ...item,
                  value: item?.label
              }
          ]

      })    
      return newArrayClients
    }

/**
 * Runs a firework animation using the confetti library.
 * The animation lasts for 5 seconds and shoots particles from two
 * different origins on the screen.
 * #unused
 * @see https://github.com/catdad/confetti
 */
export const runFireworks = () => {
  var duration = 5 * 1000;
  var animationEnd = Date.now() + duration;
  var defaults = { startVelocity: 30, spread: 360, ticks: 60, zIndex: 0 };

  function randomInRange(min, max) {
    return Math.random() * (max - min) + min;
  }

  var interval = setInterval(function() {
    var timeLeft = animationEnd - Date.now();

    if (timeLeft <= 0) {
      return clearInterval(interval);
    }

    var particleCount = 50 * (timeLeft / duration);
    // since particles fall down, start a bit higher than random
    confetti(Object.assign({}, defaults, { particleCount, origin: { x: randomInRange(0.1, 0.3), y: Math.random() - 0.2 } }));
    confetti(Object.assign({}, defaults, { particleCount, origin: { x: randomInRange(0.7, 0.9), y: Math.random() - 0.2 } }));
  }, 250);
}


/**
 * It gets the user information stored in the local storage. If it is not found, it clears
 * the local storage
 * #unused
 * @returns {Object} - the user information
 */
export const fetchUser = () => {

  const userInfo = localStorage.getItem('user') !== 'undefined'
      ? JSON.parse(localStorage.getItem('user'))
      : localStorage.clear();
      
      //console.log("fetch user info: ",userInfo)

      return userInfo

}

/**
 * Returns an array of all non-conformities associated with a given template.
 * The non-conformities are retrieved from the global state and filtered by the
 * template id.
 * If an array of non-conformities is provided, it is used instead of the global state.
 * The function also flattens the array of non-conformities and removes any duplicates.
 * #nonConformities
 * @param {Object} template - The template object
 * @param {Array} nonConformities - The array of non-conformities to filter
 * @returns {Array} - The array of filtered non-conformities
 */
export const allTemplateNonConformities = (template, nonConformities=[]) => {
  //const {nonConformities} = useStateContext();
  const generatedNonConformities = template?.fields
  ?.filter?.((x)=>x.fieldGeneratedNonConformity)
  .map?.((item)=>item.nonConformities)
  .flat(1)
  const maintenanceNonConformities = template?.dates
  ?.filter?.((x)=>x.fieldGeneratedNonConformity)
  .map?.((item)=>item.nonConformities)
  .flat(1)
  
  
  const templateNonConformities = Array.isArray(nonConformities) ? nonConformities?.filter?.((x)=>{
    const registerFound = !Array.isArray(x?.registers) ? undefined : x?.registers?.find?.((y)=>y?._ref==template?._id)
    return template?._id == registerFound?._ref
  }) : []


  const templateFieldNonConformities = generatedNonConformities ? generatedNonConformities : []
  const templateMaintenanceNonConformities = maintenanceNonConformities ? maintenanceNonConformities : []
  const allTemplateNonConformities = [...templateNonConformities,...templateFieldNonConformities, ...templateMaintenanceNonConformities]
  return allTemplateNonConformities
}

/**
 * Retrieves the last check date and log entry for a given device and log type
 * Returns an object with two properties: date and log
 * The date is the most recent check date for the given device and log type
 * The log is the log entry for the given device and log type at the most recent check date
 * #historyLogs
 * @param {Object} device - The device object
 * @param {string} logType - The log type to check for
 * @returns {Object} - An object with two properties: date and log
 */
export const userLogCheck = (device, logType = "check") => {
  const checkDates = !Array.isArray(device?.userLog) ? [] : device?.userLog?.filter?.(x=>x?.logType == logType).map?.((item)=>{
    return item.date
}).sort(function(a, b){return b - a})

const lastCheckDate = checkDates && checkDates[0]
const lastCheck = !Array.isArray(device?.userLog) ? [] : device?.userLog?.filter?.(x=>x?.logType ==logType)?.find?.((x)=>x.date==lastCheckDate)
//console.log("lawehjdlqaewhc",lastCheckDate )
return ({
  date: lastCheckDate,
  log: lastCheck
})
}

/**
 * Sorts two strings numerically.
 * #core #sortBy
 * Returns undefined if either string is undefined or null.
 * Otherwise, returns the result of the numeric localeCompare comparison.
 * @param {string} a - The first string to compare
 * @param {string} b - The second string to compare
 * @returns {number} The result of the numeric localeCompare comparison
 */
export const sortByNumeric = ( a, b ) => {
   if(!a || !b) return undefined
    return a?.localeCompare(b, undefined, {
      numeric: true,
      sensitivity: 'base'
    })}

/**
 * Sorts two devices based on their template field values.
 * #deviceFields
 * @param {Object} a - The first device to compare
 * @param {Object} b - The second device to compare
 * @param {string} sortType - The type of sorting to perform.
 * Supported values: "Piano" and "Posizione".
 * @returns {number} The result of the sorting comparison.
 */
export const sortDevices = (a,b,sortType) => {

  let templateId

  switch(sortType){
      case "Piano": 
      //console.log("in Piano")
      templateId = "100089e6-e85d-467f-92b2-958628470ea2"
      break
      default :
      //console.log("in Default")
      templateId = "5710d994-8bc9-4981-a5af-94a535d27bbd"

  }

  
/**
 * Retrieves the value of a device's template field given its id.
 * #core #sortBy
 * @param {Object} device - The device object
 * @param {string} id - The id of the template field
 * @returns {string|number} The value of the device's template field given its id, or 0 if not found
 */
  const sortValue = (device={}, id) => {
      const locations = !device?.locations ? [] : device?.locations
      const fields = !device?.fields ? [] : device?.fields
      const array =[...locations,...fields]
      const obj = !Array.isArray(array) ? undefined : array?.find?.(x=>x.templateField._ref == id)
      const value = obj?.values?.[0].value
      return !value ? 0 : value
  }

  const firstElement = sortValue(a, templateId) ? sortValue(a, templateId)?.toLowerCase() : 0
  const secondElement = sortValue(b, templateId) ? sortValue(b, templateId)?.toLowerCase() : 0
  
  return sortByNumeric(firstElement, secondElement )

}

// DATE OBJECT FUNCTIONS {year, month}

/**
 * Returns a string representing the date in the format "MM/DD/YYYY".
 * The day of the month is always 1.
 * #deadlines
 * @param {Object} dateObject - The object containing the year and month
 * @returns {string} The formatted date string
 */
export const formatDateFromDateObject = (dateObject) => {
  return `${dateObject?.month}/01/${dateObject?.year}`
}
/**
 * Returns a string representing the date in the format "MM/YYYY".
 * If the date object does not contain a year, an empty string is returned.
 * #deadlines
 * @param {Object} dateObject - The object containing the year and month
 * @returns {string} The formatted date string
 */
export const monthYearFromDateObject = (dateObject) => {
  // #deadlines
  if(!dateObject?.year) return ""
  return `${dateObject?.month ? dateObject?.month : 1}/${dateObject?.year}`
}

/**
 * Returns the number of milliseconds since January 1, 1970, 00:00:00 UTC
 * represented by the given date object.
 * #deadlines
 * @param {Object} dateObject - The object containing the year and month
 * @returns {number} The number of milliseconds since January 1, 1970, 00:00:00 UTC
 */
export const dateObjectToMillis = (dateObject) => {
  // #deadlines
  return new Date(formatDateFromDateObject(dateObject))?.getTime()
}

/**
 * Returns a new date object with the months added to the given date object.
 * If the result of adding the months is greater than 12, it will return a date object with the month decremented by 12 and the year incremented by 1.
 * #deadlines
 * @param {Object} dateObject - The object containing the year and month
 * @param {number} monthsToAdd - The number of months to add
 * @returns {{month: number, year: number}} - a date object with the added months
 */
export const formattedDateObjWithOverMonths = (dateObject, monthsToAdd) => {
  // #deadlines
  const monthsRemainder = monthsToAdd % 12
  const nYears = (monthsToAdd - monthsRemainder)/12

  const newMonths = dateObject?.month + monthsRemainder

  const addedMonths = {month: newMonths, year: dateObject?.year + nYears}
  const overAddedMonths = {month: newMonths - 12, year: dateObject?.year + nYears + 1}

  if(newMonths > 12) return overAddedMonths
  return addedMonths
}

/**
 * Returns a date object with the current month and year.
 * If customYear is provided, it will use that year instead of the current year.
 * #deadlines
 * @param {number} customYear - the year to use instead of the current year
 * @returns {{month: number, year: number}} - a date object with the current month and year
 */
export const currentDateObject = (customYear) => {
  const today = new Date()
  const doc = {month: today.getMonth() + 1 , year: Number(customYear) ? Number(customYear) : today.getFullYear()}
  //if(customYear) console.log("customYear in CurrentDateObject qljdslqwdj", {customYear, doc})
  return doc }

/**
 * Returns a date object with the months added to the given date object.
 * If the result of adding the months is greater than 12, it will return a date object with the month decremented by 12 and the year incremented by 1.
 * The function will also return an extra property "expired" which is true if the date object with the added months is before the current date, and false otherwise.
 * #deadlines
 * @param {Object} dateObject - The object containing the year and month
 * @param {number} monthsToAdd - The number of months to add
 * @param {number} customYear - The year to use instead of the current year
 * @returns {{month: number, year: number, expired: boolean}} - a date object with the added months and the expired property
 */
export const addMonthsToDateObject = (dateObject, monthsToAdd, customYear) => {

  const currentDate = currentDateObject(customYear)
  
  const newDate = formattedDateObjWithOverMonths(dateObject, monthsToAdd)

  const currentDateMillis = dateObjectToMillis(currentDate)
  const dateMillis = dateObjectToMillis(newDate)

  const doc = {...newDate, expired: dateMillis < currentDateMillis ? true : false}
  
  return doc
}


/**
 * Function to check if a deadline has passed
 * #deadlines
 * @param {number} date - the year of the deadline
 * @param {boolean} notGreen - if true, the compliant status will not have the green color
 * @returns {object} - object with the following properties:
 *  - color: string
 *  - nonConformity: boolean
 *  - status: string
 *  - textColor: string
 *  - date: number
 */
export const deadlineChecker = (date, notGreen=false) => {
   // #deadlines
   const currentYear = new Date().getFullYear()
   
   if (!date) return ({
    //color:"red",
    nonConformity:false,
    status: "NULL",
    textColor: "white",
    date: undefined
    })

   if (date < currentYear) return ({
       color:"red",
       nonConformity: true,
       status: "OVER",
       textColor: "white",
       date: date
   })
   if (date == currentYear) return ({
       color:"yellow",
       nonConformity:true,
       status: "CURRENT",
       date: date,

   })
   if (date == currentYear + 1) return ({
       color:"blue",
       textColor: "white",
       nonConformity:true,
       status:"NEXT YEAR",
       date: date,
   })

   return {
       color: !notGreen ? "green":"",
       status:"COMPLIANT",
       date: date,
   }
}
/**
 * 
 * @param {object} dateObject - object with year and month
 * @param {boolean} notGreen - if true, the compliant status will not have the green color
 * @param {boolean} byMonth - if true, it will check if the deadline is passed by month
 * @param {string|number} customYear - custom year to check the deadline against
 * #deadlines
 * @returns {object} - object with the following properties:
 *  - color: string
 *  - nonConformity: boolean
 *  - status: string
 *  - textColor: string
 *  - date: string
 *  - monthly: boolean (only if byMonth is true)
 */
export const deadlineObjectChecker = (dateObject, notGreen=false, byMonth=false, customYear) => {
  //   visualizzato
  const today = currentDateObject(customYear)
  const todayMillis = dateObjectToMillis(today)
  const objMillis = dateObjectToMillis(dateObject)
    
  if (!dateObject || (!dateObject?.year && !dateObject?.month )) return ({
   //color:"red",
   nonConformity: false,
   status: "NULL",
   textColor: "white",
   date: undefined
   })

  if (byMonth && objMillis <= todayMillis) return ({
    color:"red",
    nonConformity: true,
    status: "OVER",
    textColor: "white",
    date: monthYearFromDateObject(dateObject),
    monthly: true
  }) 
  if (!byMonth && dateObject?.year <= today?.year) return ({
      color:"red",
      nonConformity: true,
      status: "OVER",
      textColor: "white",
      date: monthYearFromDateObject(dateObject)
  })

  if (dateObject?.year == today?.year + 1) return ({
      color:"blue",
      textColor: "white",
      nonConformity: true,
      status:"NEXT YEAR",
      date: monthYearFromDateObject(dateObject),
  })

  return {
      color: !notGreen ? "green":"",
      status:"COMPLIANT",
      date: monthYearFromDateObject(dateObject),
  }
}

/**
 * Adds a leading zero to a number if it is less than 10.
 * #core
 * @param {number} number - the number to add a leading zero to
 * @returns {string} the string representation of the number with a leading zero if necessary
 */
export const addZero = (number) => 
  number< 10 ? "0" + number : number

/**
 * Returns an array of unique strings from the given array
 * #core
 * @param {string[]} arr - The array of strings
 * @returns {string[]} - An array of unique strings
 */
export const getUniqueStrings = (arr) => {
  return [...new Set(arr)];
}
/**
 * #core #historyLogs
 * @param {*} date millDate: date in milliseconds from wichi I want to calculate the time passed until now
 * @param {*} justDate bool: if true, always show date, if false shows "now", "... minutes ago", "... hour ago", "... hours ago", "yesterday" and finally the date,
 * @returns formatted date dd/mm/yyyy or string + time passed
 */
export const timePassedTranslated = (date, justDate, dateAndTime) => {
  const { LDB } = useStateContext();
  const now = Date.now()
  const passedMills = now - date
  const milliseconds = Math.floor((passedMills % 1000) / 100)
  const seconds = Math.floor((passedMills / 1000) % 60)
  const minutes = Math.floor((passedMills / (1000 * 60)) % 60)
  const hours = Math.floor((passedMills / (1000 * 60 * 60)) % 24)

  const dateObject = new Date(date)
  const dateSplit = {
      year: dateObject.getFullYear(),
      month: addZero(dateObject.getMonth()+1),
      day: addZero(dateObject.getDate()),
      hours: dateObject?.getHours(),
      minutes: dateObject?.getMinutes() < 10 ? "0" + dateObject?.getMinutes() : dateObject?.getMinutes(),
  }
    const {year,month,day} = dateSplit
    const formattedDate = day + "/" + month + "/" + year
    const formattedTime = dateSplit?.hours + ":" + dateSplit?.minutes
    //console.log("Formatted date", formattedTime)

  if(!justDate && passedMills < 1.728e+8){
    if(passedMills < 120000) return LDB(P, "now")
    if(passedMills < 3.6e+6) return minutes + " " + LDB(P, "minutesAgo")
    if(passedMills < 7.2e+6) return hours + " " + LDB(P, "hourAgo") + " "
    if(passedMills < 8.64e+7) return hours + " " + LDB(P, "hoursAgo")
    if(passedMills < 1.728e+8 && !dateAndTime) return " " + LDB(P, "yesterday")
    if(passedMills < 1.728e+8 &&  dateAndTime) return` ${LDB(P, "yesterday")} ALLE ${formattedTime}`
  }

  if(dateAndTime) return `${formattedDate} ALLE ${formattedTime}`
  return formattedDate 
}

/**
 * Returns a string representing the month and year of the given date.
 * #core #historyLogs
 * @param {number} date - the date in milliseconds
 * @returns {string} - the string representation of the month and year
 * @example
 * monthAndYear(1643723900000) // "FEBBRAIO 2022"
 */
export const monthAndYear = (date) => {
  const dateObject = new Date(date)
  const dateSplit = {
      year: dateObject.getFullYear(),
      month: dateObject.toLocaleString('it-IT', { month: 'long' }), // Get full month name
  }

  const { year, month } = dateSplit
  const formattedDate = `${month?.toUpperCase()} ${year}`

  return formattedDate 
}


/**
 * #core #historyLogs
 * Returns a string representing the time passed since the given date.
 * If the given date is within the last 2 minutes, it returns "ora".
 * If the given date is within the last hour, it returns "X minuti fa".
 * If the given date is within the last 24 hours, it returns "X ora fa".
 * If the given date is within the last 48 hours, it returns "X ore fa".
 * If the given date is older than 48 hours, it returns the date in the format "DD/MM/YYYY".
 * If justDate is true, it always returns the date in the format "DD/MM/YYYY".
 * @param {number} date - the date in milliseconds
 * @param {boolean} justDate - if true, always returns the date in the format "DD/MM/YYYY"
 * @returns {string} - the string representation of the time passed or the date
 */
export const timePassed = (date, justDate) => {
  
  const now = Date.now()
  const passedMills = now - date
  const milliseconds = Math.floor((passedMills % 1000) / 100)
  const seconds = Math.floor((passedMills / 1000) % 60)
  const minutes = Math.floor((passedMills / (1000 * 60)) % 60)
  const hours = Math.floor((passedMills / (1000 * 60 * 60)) % 24)

  //hours = (hours < 10) ? "0" + hours : hours;
  //minutes = (minutes < 10) ? "0" + minutes : minutes;
 // seconds = (seconds < 10) ? "0" + seconds : seconds;
//"h "+ hours + ":" + minutes + ":" + seconds + "." + milliseconds;

  if(!justDate && passedMills < 120000) return "ora"
  if(!justDate && passedMills < 3.6e+6) return minutes + " minuti fa"
  if(!justDate && passedMills < 7.2e+6) return hours + " ora fa "
  if(!justDate && passedMills < 8.64e+7) return hours + " ore fa "
  if(!justDate && passedMills < 1.728e+8) return " ieri"

  const dateObject = new Date(date)
  const dateSplit = {
      year: dateObject.getFullYear(),
      month: addZero(dateObject.getMonth()+1),
      day: addZero(dateObject.getDate())
  }
    const {year,month,day} = dateSplit
    const formattedDate = day + "/" + month + "/" + year
    //console.log("Formatted date", day)

  return formattedDate 
}


/**
 * Creates multiple documents in Sanity using the given query.
 * #queries
 * @param {Array} items - Array of items to create
 * @param {Function} query - Query to use for creating the documents. The query should take an item as an argument and return a promise.
 * @returns {Promise<Array>} Promise that resolves with an array of created documents
 */
export async function createMany (items, query) {
  //query: sanityclient.create(item)
  const promises = items.map?.(async item => {
    await query(item)
  })
  const results = await Promise.all(promises)
  results.forEach(result => {
    //console.log(result)
  })
  // setResults(results)
}


/**
 * Returns the window's local storage object.
 * #core
 * @returns {Storage} The local storage object.
 */
export const windowStorage = () => 
  window.localStorage

/**
 * Returns an array with unique combinations of the given array based on the given key.
 * If the array is empty or the objectKey is undefined, an empty array is returned.
 * #core
 * @param {string} objectKey - The key to use for creating unique combinations
 * @param {Array} array - The array to filter
 * @returns {Array} Array with unique combinations based on the given key
 */
export const unique = (objectKey, array) => {
  if (!Array.isArray(array) || array.length === 0 || !objectKey) return [];
  
  const arrayUniqueByKey = [...new Map(array.map?.(item =>
    [item?.[objectKey], item])).values()];
    
  return arrayUniqueByKey;
};

/**
 * Creates unique combinations based on multiple keys
 * @param {string[]} keys - Array of keys to create unique combinations from
 * @param {Array} array - Array to filter
 * @param {Function} priorityFn - Optional function to determine which item to keep when duplicates are found
 * @returns {Array} Array with unique combinations
 */
export const uniqueByMultipleKeys = (keys, array, priorityFn) => {
  if (!Array.isArray(array) || array.length === 0 || !Array.isArray(keys) || keys.length === 0) return [];
  
  const seen = new Map();
  const result = [];
  
  for (const item of array) {
    // Create a compound key from all specified keys
    const compoundKey = keys.map(key => item?.[key]).join('|');
    
    if (!seen.has(compoundKey)) {
      seen.set(compoundKey, item);
      result.push(item);
    } else if (priorityFn) {
      // If priority function is provided, use it to determine which item to keep
      const existingItem = seen.get(compoundKey);
      const preferredItem = priorityFn(existingItem, item);
      if (preferredItem === item) {
        seen.set(compoundKey, item);
        // Replace the item in result array
        const existingIndex = result.findIndex(r => r === existingItem);
        if (existingIndex !== -1) {
          result[existingIndex] = item;
        }
      }
    }
  }
  
  return result;
};


/**
 * Updates the array of devices by removing the device with the given id and adding the updated document.
 * #devices
 * @param {Array} devices - The array of devices to update
 * @param {Function} setDevices - The function to update the devices array
 * @param {Object} device - The device to remove from the array
 * @param {Object} updateDoc - The updated document to add to the array
 */
export const updateDevices = (devices, setDevices, device, updateDoc) => {

  const filterDevices = devices.filter?.((x)=>x?._id !== device?._id)
  setDevices([...filterDevices, updateDoc])

}
/**
 * #registers
 * Updates the array of registers by removing the register with the given id and adding the updated document.
 * @param {Array} registers - The array of registers to update
 * @param {Function} setRegisters - The function to update the registers array
 * @param {Object} register - The register to remove from the array
 * @param {Object} updatedRegister - The updated document to add to the array
 */
export const updateRegisters = (registers, setRegisters, register, updatedRegister) => {

  const filterRegisters = registers.filter?.((x)=>x?._id !== register?._id)
  //ADD UPDATED DEVICE TO REGISTER

  setRegisters([...filterRegisters, updatedRegister])
}


/**
 * Updates the array of devices by removing the device with the given id and adding the updated document.
 * #deviceNonConformities
 * @param {Array} array - The array of devices to update
 * @param {Function} setData - The function to update the devices array
 * @param {Object} nonConformity - The device to remove from the array
 * @param {Object} updateDoc - The updated document to add to the array
 */
export const updateDeviceNonConformities = (array, setData, nonConformity, updateDoc) => {

  let findCurrentDeviceIndex = () => array?.findIndex((x)=>x?._id === nonConformity?._id)
  array.splice(findCurrentDeviceIndex(),1)
  setData([...array, {...updateDoc}])
  //setDevices([...devices, {...updateDoc, comments:device?.comments}])
}


/**
 * #core
 * Exports the given data as a JSON file. The filename is set to 'data.json'.
 * @param {Object} data - The data to export as JSON
 */
export const exportJSON = (data) => {
  const jsonString = `data:text/json;chatset=utf-8,${encodeURIComponent(
    JSON.stringify(data)
  )}`;
  const link = document.createElement("a");
  link.href = jsonString;
  link.download = "data.json";

  link.click();
};

/**
 * Returns the nPostazione from the given device. If the device does not have a location
 * #deviceFields
 * with the templateField of id "5710d994-8bc9-4981-a5af-94a535d27bbd", or if the location
 * does not have a value at index 0, returns an empty string.
 * @param {Object} device - The device to get the nPostazione from
 * @returns {string} The nPostazione of the device, or an empty string if not found
 */
export const nPostazione = (device) => 
  !Array.isArray(device?.locations) ? "" : device?.locations?.find?.(x=>x?.templateField?._ref=="5710d994-8bc9-4981-a5af-94a535d27bbd")?.values?.[0]?.label

/**
 * Returns the matricola from the given device. If the device does not have a field
 * #deviceFields
 * with the templateField of id "f0fd3f90-ef02-4dae-a4df-dfff44aba409", or if the field
 * does not have a value at index 0, returns an empty string.
 * @param {Object} device - The device to get the matricola from
 * @returns {string} The matricola of the device, or an empty string if not found
 */
export const matricola = (device) => 
  !Array.isArray(device?.fields) ? "" : device?.fields?.find?.(x=>x?.templateField?._ref=="f0fd3f90-ef02-4dae-a4df-dfff44aba409")?.values?.[0]?.label

/**
 * Returns a string representing the client name. If the client is a commune, returns "COMUNE DI <client.label>".
 * Otherwise, returns the client label.
 * #anagraficheManagement
 * @param {Object} client - The client object
 * @returns {string} The client name
 */
export const  clientName = (client) => {
  
  if(!client?.notComune) return `COMUNE DI ${client?.label}`
  return client?.label
}

/**
 * Shows a success alert with the given title. The alert will be displayed for 1500ms and will be positioned at the top of the screen.
 * #core
 * @param {string} [title=""] - The title of the alert
 */
export const successAlert = (title = "") => {
  
  Swal.fire({
      position: 'top',
      icon: 'success',
      title: title,
      showConfirmButton: false,
      timer: 1500
    })
}
/**
 * Shows an error alert with the given title. The alert will be displayed for 3500ms and will be positioned at the top of the screen.
 * #core
 * @param {string} [title=""] - The title of the alert
 */
export const errorAlertSwal = (title = "") => {
  Swal.fire({
      position: 'top',
      icon: 'error',
      title: title,
      showConfirmButton: false,
      timer: 3500
    })
}
/**
 * Shows an information alert with the given title. The alert will be displayed for 3500ms and will be positioned at the top of the screen.
 * #core
 * @param {string} [title=""] - The title of the alert
 */
export const infoAlert = (title = "") => {
  Swal.fire({
      position: 'top',
      icon: 'warning',
      title: title,
      showConfirmButton: false,
      timer: 3500
    })
}
/**
 * Shows an error alert with the given title. The alert will be displayed for an infinite amount of time and will be positioned at the top of the screen.
 * If an error is provided, a button will be displayed to send the error report to the developers via email.
 * #core
 * @param {string} [message=""] - The title of the alert
 * @param {Object} [error=undefined] - The error object to send in the report
 */
export const errorAlert = async(message = "", error = undefined) => {
  const fullErrorMessage = error 
    ? `${message}\n\nError Details:\n${JSON.stringify(error, Object.getOwnPropertyNames(error), 2)}`
    : message;

  toast.error(
    (t) => {
      return React.createElement(
        'div',
        undefined,
        React.createElement('div', undefined,
          React.createElement('p', undefined, message)
        ),
        React.createElement(
          'div',
          { 
            style: { 
              marginTop: '10px', 
              display: 'flex', 
              gap: '10px' 
            } 
          },

          error && React.createElement(
            'button',
            {
              onClick: async() => {
                
                await postingEmail({
                  subject: error?.subject || error?.message, 
                  toEmail: "yourmindup@Gmail.com", 
                  text: `GSSMEGA ERROR hqihuwd8`,
                  stringifiedJson: JSON.stringify(error)
                })
                toast.dismiss(t.id);
              },
              style: {
                padding: '5px 10px',
                backgroundColor: '#4CAF50',
                color: 'white',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer'
              }
            },
            'Spedisci Report Errore'
          ),
          React.createElement(
            'button',
            {
              onClick: () => toast.dismiss(t.id),
              style: {
                padding: '5px 10px',
                backgroundColor: '#f44336',
                color: 'white',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer'
              }
            },
            'Chiudi'
          )
        )
      );
    },
    {
      duration: Infinity,
      style: {
        padding: '16px',
        borderRadius: '8px',
        maxWidth: '500px'
      }
    }
  );
};

/**
 * Sorts objects by their updatedAt date in ascending order.
 * #core #sortBy
 * @param {Object} a - The first object to compare
 * @param {Object} b - The second object to compare
 * 
 * @returns {number} - A negative number if the updatedAt date of a is before the updatedAt date of b,
 * a positive number if the updatedAt date of a is after the updatedAt date of b, and zero if the updatedAt dates are equal.
 */
export const sortByUpdatedAtDate = (a,b) => {
  // Turn your strings into dates, and then subtract them
  // to get a value that is either negative, positive, or zero.
  return new Date(b._updatedAt) - new Date(a._updatedAt);
}
/**
 * Sorts objects by their updatedAt date in descending order.
 * #core #sortBy
 * @param {Object} a - The first object to compare
 * @param {Object} b - The second object to compare
 * 
 * @returns {number} - A negative number if the updatedAt date of a is after the updatedAt date of b,
 * a positive number if the updatedAt date of a is before the updatedAt date of b, and zero if the updatedAt dates are equal.
 */
export const sortByUpdatedAtDateDesc = (a,b) => {
  // Turn your strings into dates, and then subtract them
  // to get a value that is either negative, positive, or zero.
  return new Date(a._updatedAt) - new Date(b._updatedAt);
}


/**
 * Sorts objects by their label in ascending order.
 * #core #sortBy
 * @param {Object} a - The first object to compare
 * @param {Object} b - The second object to compare
 * 
 * @returns {number} - A negative number if the label of a is before the label of b,
 * a positive number if the label of a is after the label of b, and zero if the labels are equal.
 */
export const sortByLabel = ( a, b ) => {

  return a?.label?.trim()?.localeCompare(b?.label?.trim(), undefined, {
    numeric: true,
    sensitivity: 'base'
  })}
/**
 * Sorts objects by their family name in ascending order.
 * #core #sortBy
 * @param {Object} a - The first object to compare
 * @param {Object} b - The second object to compare
 * 
 * @returns {number} - A negative number if the family of a is before the family of b,
 * a positive number if the family of a is after the family of b, and zero if the families are equal.
 */
  export const sortByFamily = ( a, b ) => {

  return a?.family?.trim()?.localeCompare(b?.family?.trim(), undefined, {
    numeric: true,
    sensitivity: 'base'
  })}
/**
 * Sorts objects by their site number in ascending order.
 * #core #sortBy
 * @param {Object} a - The first object to compare
 * @param {Object} b - The second object to compare
 * 
 * @returns {number} - A negative number if the site number of a is before the site number of b,
 * a positive number if the site number of a is after the site number of b, and zero if the site numbers are equal.
 */
  export const sortBySiteNumber = ( a, b ) => {

    return a?.siteNumber?.localeCompare(b?.siteNumber, undefined, {
      numeric: true,
      sensitivity: 'base'
    })}

/**
 * Sorts objects by their label, considering dates in the format dd/mm/yyyy first.
 * If both items have dates, compare dates first. If the dates are equal, compare the labels.
 * If one or both items do not have dates, compare the labels directly.
 * #core #sortBy
 * @param {Object} a - The first object to compare
 * @param {Object} b - The second object to compare
 * 
 * @returns {number} - A negative number if the label (or date) of a is before the label (or date) of b,
 * a positive number if the label (or date) of a is after the label (or date) of b, and zero if the labels (or dates) are equal.
 */
  export const sortByLabelAndDate = ( a, b ) => {
    // Extract dates using regex - matches dd/mm/yyyy format
    const dateRegex = /(\d{2}\/\d{2}\/\d{4})/;
    const dateA = a?.label?.match(dateRegex)?.[0];
    const dateB = b?.label?.match(dateRegex)?.[0];

    // If both items have dates, compare dates first
    if (dateA && dateB) {
      const [dayA, monthA, yearA] = dateA.split('/').map?.(Number);
      const [dayB, monthB, yearB] = dateB.split('/').map?.(Number);
      
      // Create Date objects for comparison
      const dateObjA = new Date(yearA, monthA - 1, dayA);
      const dateObjB = new Date(yearB, monthB - 1, dayB);
      
      if (dateObjA - dateObjB !== 0) {
        return dateObjA - dateObjB;
      }
    }

    // If no dates or dates are equal, compare by label
    return a?.label?.localeCompare(b?.label, undefined, {
      numeric: true,
      sensitivity: 'base'
    });
  }

/**
 * Sorts objects by their label in descending order.
 * #core #sortBy
 * @param {Object} a - The first object to compare
 * @param {Object} b - The second object to compare
 * 
 * @returns {number} - A negative number if the label of a is after the label of b,
 * a positive number if the label of a is before the label of b, and zero if the labels are equal.
 */
  export const sortByLabelDesc = ( a, b ) => {

    return b?.label?.localeCompare(a?.label, undefined, {
      numeric: true,
      sensitivity: 'base'
    })}

/**
 * Sorts objects by their id in ascending order.
 * #core #sortBy
 * @param {Object} a - The first object to compare
 * @param {Object} b - The second object to compare
 * 
 * @returns {number} - A negative number if the id of a is before the id of b,
 * a positive number if the id of a is after the id of b, and zero if the ids are equal.
 */
    export const sortById = ( a, b ) => {

      return a?._id?.localeCompare(b?._id, undefined, {
        numeric: true,
        sensitivity: 'base'
      })}

/**
 * Sorts objects by their name in ascending order.
 * #core #sortBy
 * @param {Object} a - The first object to compare
 * @param {Object} b - The second object to compare
 * 
 * @returns {number} - A negative number if the name of a is before the name of b,
 * a positive number if the name of a is after the name of b, and zero if the names are equal.
 */
export const sortByName = ( a, b ) => {

  return a?.name?.localeCompare(b?.name, undefined, {
    numeric: true,
    sensitivity: 'base'
  })}


/**
 * Sorts objects by their last name in ascending order.
 * #core #sortBy
 * @param {Object} a - The first object to compare
 * @param {Object} b - The second object to compare
 * 
 * @returns {number} - A negative number if the last name of a is before the last name of b,
 * a positive number if the last name of a is after the last name of b, and zero if the last names are equal.
 */
  export const sortByLastName = ( a, b ) => {

    return a?.lastName?.localeCompare(b?.lastName, undefined, {
      numeric: true,
      sensitivity: 'base'
    })}

/**
 * Sorts objects by their order in ascending order.
 * #core #sortBy
 * @param {Object} a - The first object to compare
 * @param {Object} b - The second object to compare
 * 
 * @returns {number} - A negative number if the order of a is before the order of b,
 * a positive number if the order of a is after the order of b, and zero if the orders are equal.
 */
  export const sortByOrder = ( a, b ) => {

    return a?.order?.toString()?.localeCompare(b?.order?.toString(), undefined, {

      numeric: true,
      sensitivity: 'base'
    })}
/**
 * Sorts objects by their position number in ascending order.
 * #core #sortBy
 * @param {Object} a - The first object to compare
 * @param {Object} b - The second object to compare
 * 
 * @returns {number} - A negative number if the position number of a is before the position number of b,
 * a positive number if the position number of a is after the position number of b, and zero if the position numbers are equal.
 */
  export const sortByPositionNumber = ( a, b ) => {

    return positionNumber(a).toString()?.localeCompare(positionNumber(b)?.toString(), undefined, {

      numeric: true,
      sensitivity: 'base'
    })}
  
/**
 * Sorts objects by their location in ascending order.
 * #core #sortBy
 * @param {Object} a - The first object to compare
 * @param {Object} b - The second object to compare
 * 
 * @returns {number} - A negative number if the location of a is before the location of b,
 * a positive number if the location of a is after the location of b, and zero if the locations are equal.
 */
    export const sortByLocation = ( a, b ) => {

      return a?.location?.toString()?.localeCompare(b?.location?.toString(), undefined, {
  
        numeric: true,
        sensitivity: 'base'
      })}

 
/**
 * Sorts objects by their date in ascending order.
 * #core #sortBy
 * @param {Object} a - The first object to compare
 * @param {Object} b - The second object to compare
 * 
 * @returns {number} - A negative number if the date of a is before the date of b,
 * a positive number if the date of a is after the date of b, and zero if the dates are equal.
 */
    export const sortByDate = ( a, b ) => {

      return a?.date?.toString()?.localeCompare(b?.date?.toString(), undefined, {
  
        numeric: true,
        sensitivity: 'base'
      })}

/**
 * Sorts two objects by their array element value in ascending order.
 * #core
 * #sortBy
 * @param {Object} a - The first object to compare
 * @param {Object} b - The second object to compare
 * 
 * @returns {number} - A negative number if the array element of a is before the array element of b,
 * a positive number if the array element of a is after the array element of b, and zero if the array elements are equal.
 */
    export const sortByArrayElement = ( a, b ) => {

      return a?.toString()?.localeCompare(b?.toString(), undefined, {
  
        numeric: true,
        sensitivity: 'base'
      })}
  
/**
 * Sorts two objects by their site name in ascending order.
 * #core #sortBy
 * @param {Object} a - The first object to compare
 * @param {Object} b - The second object to compare
 * 
 * @returns {number} - A negative number if the site name of a is before the site name of b,
 * a positive number if the site name of a is after the site name of b, and zero if the site names are equal.
 */
    export const sortBySite = ( a, b ) => {

      return a?.site?.toString()?.localeCompare(b?.site?.toString(), undefined, {
  
        numeric: true,
        sensitivity: 'base'
      })}


/**
 * Sorts two strings numerically.
 * #core #sortBy
 * @param {string} a - The first string to compare
 * @param {string} b - The second string to compare
 * 
 * @returns {number} - A negative number if the string a is before the string b,
 * a positive number if the string a is after the string b, and zero if the strings are equal.
 */
  export const sortNumeric = ( a, b ) => {

    return a.localeCompare(b, undefined, {
      numeric: true,
      sensitivity: 'base'
    })}

/**
 * Sorts objects by their postedOn date in ascending order.
 * #core #sortBy
 * @param {Object} a - The first object to compare
 * @param {Object} b - The second object to compare
 * 
 * @returns {number} - A negative number if the postedOn date of a is before the postedOn date of b,
 * a positive number if the postedOn date of a is after the postedOn date of b, and zero if the postedOn dates are equal.
 */
export const  sortByPostedOn = ( a, b ) => {
    if ( a?.postedOn < b?.postedOn ){
      return -1;
    }
    if ( a?.postedOn > b?.postedOn ){
      return 1;
    }
    return 0;
  }

/**
 * Removes all properties from an object that have a value of undefined.
 * #core
 * @param {Object} obj - The object to remove empty properties from
 * @returns {Object} - The object with all empty properties removed
 */
export const removeEmptyProperties = (obj) => {
    return Object.fromEntries(Object.entries(obj).filter?.(([_, v]) => v != undefined));
  }
/**
 * Removes all properties from an object that have a value of an empty string.
 * #core
 * @param {Object} obj - The object to remove empty string properties from
 * @returns {Object} - The object with all empty string properties removed
 */
export const removeEmptyStrings = (obj) => {
    return Object.fromEntries(Object.entries(obj).filter?.(([_, v]) => v != ""));
  }

/**
 * Checks if the given document is in draft mode.
 * #databaseManagement
 * @param {Object} document - The document to check
 * @returns {boolean} - True if the document is in draft mode, false otherwise
 */
export const isIdDraft = (document) => {
  if(document._id?.startsWith("drafts")){
    console.log("DOCUMENT IS IN DRAFT MODE", document)
    return true
  }
  return false
}

/**
 * 
 * @param {*} doc document of _type: device or _type deviceNonConformity
 * @param {*} status string: the new status of the document
 * #devices
 * @returns the updated document ready to be queried
 */
export const updateDeviceStatusDoc = (doc, status) => {

if(doc?._type !== "deviceNonConformity" && doc?._type !== "device") {
  console.log("DOC IS NOT OF TYPE device OR deviceNonConformity")
  return false
}

return ({...doc, status })

}

/**
 * Given an item and a LDB object, returns the translated label of the item.
 * The translations are hardcoded for specific item._id values.
 * If the item._id is not recognized, the item.label is returned.
 * #deviceFields
 * @param {Object} item - The item to translate the label of
 * @param {Object} LDB - The LDB object to use for translation
 * @returns {string} - The translated label of the item
 */
export const translatedLabel = (item, LDB) => {
  if(item?._id == "5710d994-8bc9-4981-a5af-94a535d27bbd") return LDB("fields", "nPost")
  if(item?._id == "100089e6-e85d-467f-92b2-958628470ea2") return LDB("fields", "floor")
  if(item?._id == "d770ea67-ef56-404d-a7be-37f18f6ea8be") return LDB("fields", "zone")
  if(item?._id == "b049d4bb-67a6-49de-bfb9-5c5df0aedc32") return LDB("fields", "productionYear")
  if(item?._id == "  2f3709d5-b5bc-4971-b17a-af23188319f1") return LDB("fields", "floor")


  
  return item?.label
} 

/**
 * Generates a unique identifier with no hyphens.
 * #core
 * @returns {string} - A unique identifier with no hyphens.
 */
export const keyId = () => 
  uuidv4().toString().replace(/-/g, '')
/**
 * Generates a shortened unique identifier with no hyphens, consisting of the first 4 characters of a uuidv4.
 * #core
 * @returns {string} - A shortened unique identifier with no hyphens.
 */
export const shortId = () => 
  uuidv4().slice(0, 4);

/**
 * Returns the index of a device in the register.devices array
 * #devices
 * @param {Object} register - The register object containing the devices array
 * @param {Object} device - The device object to find in the register.devices array
 * @returns {Number} - The index of the device in the register.devices array, or -1 if not found
 */
export const deviceIndex = 
(register, device) => register?.devices?.findIndex(x=>x?._id == device?._id)

/**
 * Returns the key of a device in the register.devices array
 * #devices
 * #queries
 * @param {Object} register - The register object containing the devices array
 * @param {Object} device - The device object to find in the register.devices array
 * @returns {string} - The key of the device in the register.devices array, or undefined if not found
 */
export const findKey = (register, device) => {
  //register?.devices?.findIndex(x=>x?._id == device?._id)
  const findDeviceKey = !Array.isArray(register?.devices) ? undefined : register?.devices?.find?.(x=>x?._id == device?._id)?._key
  //console.log("device", findDeviceKey)
  return(findDeviceKey)
}

/**
 * Optimistic mutation for updating the devices array in the cache.
 * It takes a queryClient, queryKey, newDoc and setData as parameters.
 * It cancels the query, gets the previous devices data from the cache, 
 * filters out the newDoc from the previous devices data, 
 * adds the newDoc to the end of the filtered array, 
 * sets the new array as the query data, 
 * and calls setData with the new array.
 * It returns an object containing the previous devices data.
 * #queries
 * #mutations
 */
export const optimisticMutation = async (queryClient, queryKey, newDoc, setData) => {
  console.log("OPTIMISTIC MUTATION hjrtfjytf")
  await queryClient.cancelQueries({ queryKey: [`'${queryKey}'`] })
  const previousDevices = queryClient.getQueryData([`'${queryKey}'`])
  queryClient.setQueryData([`'${queryKey}'`], (old) =>{ 
      const oldData = old?.length > 0 ? old : []
      const newData = [...oldData?.filter?.(x=>old?._id!==newDoc?._id), newDoc]
      setData(newData)
      return newData
  })
  return { previousDevices }
}
/**
 * Takes an array of device logs and an array of users and returns an array of device logs
 * with the postedBy field expanded to include the user object from the users array.
 * 
 * #historyLogs
 * @param {Array} deviceLogs - An array of device log objects
 * @param {Array} users - An array of user objects
 * @returns {Array} - An array of device log objects with the postedBy field expanded to include the user object
 */
export const deviceLogsExpanded = (deviceLogs, users) => { 
        
  return deviceLogs?.map?.((log=>{
      const ref = log?.postedBy?._ref
      const matchUser = !Array.isArray(users) ? {} : users?.find?.(x=>x?._id == ref)
      return ({...log, postedBy: matchUser})
}))}

/**
 * Determines if a device non-conformity is severe.
 * #nonConformities
 * The function checks if any comments in the device non-conformity are marked as severe and not archived.
 * It also checks if there is a related template non-conformity with a notification.
 * 
 * @param {Object} deviceNonConformity - The non-conformity object related to a specific device.
 * @param {Array} nonConformities - Array of template non-conformity objects.
 * @returns {boolean} - Returns true if the non-conformity is severe, false otherwise.
 */

export const isNonConformitySevere = (deviceNonConformity, nonConformities) => {
  //console.log(templateNonConformity)
  const templateNonConformity = !Array.isArray(nonConformities) ? undefined : nonConformities?.find?.((x)=>x?._id==deviceNonConformity?.nonConformity?._ref)
  if(Array.isArray(deviceNonConformity?.comments) && deviceNonConformity?.comments?.filter?.((y)=>y?.status !== "ARCHIVIATO")?.some?.(z=>z?.severe == true)) return true
  if (templateNonConformity?.notification) return true
  return false
}
/**
 * Checks if a device has a severe non-conformity or a severe comment.
 * #nonConformities #comments
 * A device is considered severe if it has a non-conformity that is severe (i.e. it has a comment marked as severe and not archived)
 * or if it has a comment marked as severe and not archived.
 * 
 * @param {Object} device - The device object to be checked.
 * @param {Array} nonConformities - Array of template non-conformity objects.
 * @returns {boolean} - Returns true if the device is severe, false otherwise.
 */
export const isDeviceSevere = (device, nonConformities) => {
  const activeDeviceNonConformities = !Array.isArray(device?.nonConformities) ? [] : device?.nonConformities.filter?.(nonConformity => nonConformity.status !== "ARCHIVIATO" && nonConformity.status !== "COMPLETATO")
  const severeNonConformityExists = activeDeviceNonConformities?.some?.((x)=>isNonConformitySevere(x, nonConformities))
  const severeCommentExists = Array.isArray(device?.comments) && device?.comments?.filter?.((y)=>y?.status !== "ARCHIVIATO")?.some?.(x=>x?.severe)
  if(severeNonConformityExists) return true
  if(severeCommentExists) return true
  return false
}


  /**
   * @function registerCollections
   * #devices #deviceNonConformities
   * @description Given an array of registers, it will return an object with two properties, devices and nonConformities.
   *              It will iterate over the devices and nonConformities of each register, adding the site and register refs to the devices and nonConformities.
   *              If bypassFilters is true, it will include all nonConformities, otherwise it will only include nonConformities that are not COMPLETATO or ARCHIVIATO.
   *              It will return an object with two properties, devices and nonConformities, which are arrays of objects.
   * @param {Array} registers - An array of registers.
   * @param {boolean} bypassFilters - If true, it will include all nonConformities, otherwise it will only include nonConformities that are not COMPLETATO or ARCHIVIATO.
   * @returns {Object} An object with two properties, devices and nonConformities, which are arrays of objects.
   */

export const registerCollections = (registers, bypassFilters) => {
  if (!Array.isArray(registers) || registers.length === 0) {
    return { devices: [], nonConformities: [] };
  }

  const collections = registers.reduce((acc, register) => {
    if (!register?.devices) return acc;

    // Process devices and nonConformities in a single iteration
    register.devices.forEach(device => {
      // Add device with site and register refs
      const deviceWithRefs = {
        ...device,
        site: {
          _ref: register?.site?._ref,
          _key: register?.site?._key || keyId()
        },
        register: {
          _ref: register?._id,
          _key: register?._key || keyId()
        }
      };
      acc.devices.push(deviceWithRefs);

      // Process nonConformities if they exist
      if (device?.nonConformities?.length) {
        device.nonConformities.forEach(nc => {
          if (bypassFilters || (nc?.status !== "COMPLETATO" && nc?.status !== "ARCHIVIATO")) {
            acc.nonConformities.push({
              ...nc,
              site: deviceWithRefs.site,
              register: deviceWithRefs.register,
              device: {
                _ref: device?._id,
                _key: device?._key || keyId()
              }
            });
          }
        });
      }
    });

    return acc;
  }, { devices: [], nonConformities: [] });

  return collections;
}


/**
 * Checks if the device has been checked within the last
 * checkResetDays days.
 * #doneCheck
 * If the device has been checked within the last checkResetDays
 * days, it will return true. Otherwise, it will return false.
 * @param {Object} device - The device object
 * @param {Object} register - The register object
 * @returns {boolean} - Whether the device has been checked within the last checkResetDays days
 */
export const isDeviceChecked = (device, register) => {
  //#doneCheck
  const lastCheckDate = userLogCheck(device)?.date
  const checkResetDays = register?.checkResetDays ? register?.checkResetDays : 120
  if(lastCheckDate) {
      const now = Date.now()
      const passedMills = now - lastCheckDate
      const nMonths = 1000 * 60 * 60 * 24 * checkResetDays
      if(passedMills < nMonths) return true  
      return false
  }
}

/**
 * Returns the current vertical scroll position of the document.
 * In Chrome, this is the scrollTop of the documentElement.
 * In Firefox, this is the scrollTop of the body element.
 * If neither is non-zero, it returns 0.
 * #core
 * @returns {number} The current vertical scroll position of the document.
 */
export const screenPosition = () => {
  const chrome = document.documentElement.scrollTop
  const firefox = document.body.scrollTop
  if(chrome !== 0) return chrome
  if(firefox !== 0) return firefox
  
  return 0
}

/**
 * Adds a new log to the document.
 * #historyLogs
 * @param {Object} sUser - The user that created the log
 * @param {Object} doc - The document to be updated with the new log
 * @param {string} logType - The type of the log (default: "log")
 * @param {Object} hystoryDoc - The history doc related to the log
 * @param {Object} position - The position of the user when the log was created
 * @param {boolean} scannedWithQr - Whether the log was scanned with QR
 * @returns {Object} The updated document with the new log
 */
export const addLogToDoc = (sUser, doc, logType="log", hystoryDoc, position, scannedWithQr) => {

  const logs = doc?.userLog ? doc?.userLog : []
  const newDoc = {...doc, _updatedAt: Date.now(), userLog:[...logs, logDoc(sUser, logType, hystoryDoc, position, scannedWithQr)]}
  return newDoc
}
/**
 * Given an array of sites, it will return an array of objects with two properties, label and value.
 * The label is a string that contains the site number and label, the value is the site label.
 * If the site number exists, it will be included in the label and value strings.
 * #anagraficheManagement
 * @param {Array} sites - An array of site objects.
 * @returns {Array} An array of objects with two properties, label and value.
 */
  export const sitesLabels = (sites) => {
        const sitesArray = sites?.length > 0 ? sites : []
        const sitesWithNumber = sitesArray?.map?.((item)=>{
            if(item?.siteNumber){
                return {
                    ...item,
                    value:`PLESSO ${item?.siteNumber}: ${item?.label}`,
                    label:`PLESSO ${item?.siteNumber}: ${item?.label}`
                }
            }
            return {
                ...item,
                value: item.label
            }
        })
        return sitesWithNumber
    }

/**
 * Given the device, device status, deadlines, client, bypass device status, and custom date,
 * it will return the device substitution status.
 * The status can be either "ATTIVO" or "DA SOSTITUIRE".
 * If the device is not substituted and the bypass device status is set to true,
 * and the deadline is not expired, it will return "ATTIVO".
 * If the device is not substituted and the bypass device status is set to false,
 * and the deadline is not expired, it will return the device status.
 * If the device is not substituted and the bypass device status is set to false,
 * and the deadline is expired, it will return "DA SOSTITUIRE".
 * If the device is substituted and the bypass device status is set to true,
 * and the deadline is not expired, it will return "ATTIVO".
 * If the device is substituted and the bypass device status is set to false,
 * and the deadline is not expired, it will return the device status.
 * If the device is substituted and the bypass device status is set to false,
 * and the deadline is expired, it will return "DA SOSTITUIRE".
 * #substituteDevice
 * #devices
 * @param {Object} device - The device object
 * @param {string} deviceStatus - The device status
 * @param {Object} deadlines - The deadlines object
 * @param {Object} client - The client object
 * @param {boolean} bypassDeviceStatus - Whether to bypass the device status
 * @param {number} customDate - The custom date
 * @returns {string} The device substitution status
 */
export const deviceSubstitutionStatus = ({device, deviceStatus, deadlines, client, bypassDeviceStatus, customDate}) =>  {
  
  const deadlineType = deadlines?.deadlineType

  const isScadCollRev = deadlineType == "Scadenza-Collaudo-Revisione" ? true : false
  const isClientRevision = client?.revision

  const expiry = deadlines?.checkData?.expiry?.date
  const revision = deadlines?.checkData?.revisione?.date
  const test = deadlines?.checkData?.collaudo?.date
  
  const currentYear = customDate ? customDate : new Date().getFullYear()
  //console.log("lsjòszjfòsoijef",{deadlines})
  if(!isClientRevision && isScadCollRev){
    //console.log("isScadCollRev and not isClientRevision")
    if(!expiry && bypassDeviceStatus) return "ATTIVO"
    if(expiry && expiry <= currentYear) return "DA SOSTITUIRE"

    //if(revision && revision <= currentYear) return "DA SOSTITUIRE"
    //if(test && test <= currentYear) return "DA SOSTITUIRE"
    if(bypassDeviceStatus && expiry > currentYear && test > currentYear && revision > currentYear) return "ATTIVO"
    return deviceStatus
  }
  if(!expiry && !bypassDeviceStatus && device?.substituteReason?.value == "SCADUTO") return "ATTIVO"
  if(!expiry && bypassDeviceStatus) return "ATTIVO"
  if(!expiry && !bypassDeviceStatus) return deviceStatus
  if(expiry && expiry <= currentYear) return "DA SOSTITUIRE"

  if(bypassDeviceStatus && expiry && expiry > currentYear) return "ATTIVO"
  if(!bypassDeviceStatus) return deviceStatus
  return "ATTIVO"
}

/**
 * Given a base64 string and an optional uploadPhotoAsset function,
 * it will convert the base64 string to a Sanity asset object.
 * It will first fetch the base64 string and then convert it to a blob.
 * It will then compress the blob using the imageCompression library.
 * It will then create a new File object using the compressed blob and the keyId function.
 * It will then create a new asset object using the fileType and the new File object.
 * It will then return the asset object.
 * If the uploadPhotoAsset function is provided, it will be called with the new asset object.
 * #pictures
 * @param {string} base64 - The base64 string to be converted
 * @param {function} uploadPhotoAsset - An optional function to be called with the new asset object
 * @returns {object} The new asset object
 */
export const fromBase64ToSanity = async (base64, uploadPhotoAsset=()=>{}) => {
 const response = await fetch(base64)
    ?.then(res => res.blob())
    ?.then(async blob => {
        const options = {
          maxSizeMB: 5, // Maximum file size in MB
          maxWidthOrHeight: 1024, // Resize image to fit within 1024px width or height
          useWebWorker: true, // Use a web worker for better performance
        };
        console.log("...compressing file", blob)
        const compressedBlob = await imageCompression(blob, options);
        const file =  new File([compressedBlob], keyId(),{ type: blob.type })
        //console.log("...compressed file", file)
        const asset = {fileType:"image", file}
        //console.log("hbjehbejhbc", asset)
        return asset
        })
      return response
    }

/**
 * Converts a base64 string to a Sanity asset object.
 * It first fetches the base64 string and then converts it to a blob.
 * It then creates a new File object using the blob and the keyId function.
 * It then creates a new asset object using the fileType and the new File object.
 * If the uploadPhotoAsset function is provided, it will be called with the new asset object.
 * This function does not compress the image, it is used for legacy images.
 * #pictures
 * @param {string} base64 - The base64 string to be converted
 * @param {function} uploadPhotoAsset - An optional function to be called with the new asset object
 * @returns {object} The new asset object
 */
    export const fromBase64ToSanityOld = async (base64, uploadPhotoAsset=()=>{}) => {
      const response = await fetch(base64)
         ?.then(res => res.blob())
         ?.then(blob => {
             const file =  new File([blob], keyId(),{ type: blob.type })
             console.log(file);
             console.log(blob);
             const asset = {fileType:"image", file}
             //console.log("hbjehbejhbc", asset)
             return asset
             })
           return response
         }

/**
 * Converts a File object to a base64 string.
 * It returns a Promise that resolves to the base64 string
 * or rejects with an error if the conversion fails.
 *  #pictures
 * @param {File} file - The File object to be converted
 * @returns {Promise<string>} A Promise that resolves to the base64 string
 */
export const convertBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const fileReader = new FileReader();
    fileReader.readAsDataURL(file);

    fileReader.onload = () => {
      resolve(fileReader.result);
    };

    fileReader.onerror = (error) => {
      reject(error);
    };
  });
};

/**
 * Resizes a base64 image to fit within a specified size in MB.
 * The image is resized while preserving its aspect ratio.
 * If the original image is PNG, it is preserved as PNG to maintain transparency.
 * Otherwise, it is converted to JPEG.
 *  #pictures
 * @param {string} base64Image - The base64 image to be resized
 * @param {number} maxSizeInMB - The maximum size of the resized image in MB (default is 0.5)
 * @returns {Promise<string>} A Promise that resolves to the resized base64 image
 */
export const resizeBase64 = (base64Image, maxSizeInMB = 0.5) => {
  return new Promise((resolve, reject) => {
    const maxSizeInBytes = maxSizeInMB * 1024 * 1024;
    const img = new Image();
    img.src = base64Image;
    img.onload = function () {
      const canvas = document.createElement("canvas");
      // Enable alpha channel to preserve transparency
      const ctx = canvas.getContext('2d', { alpha: true });
      const width = img.width;
      const height = img.height;
      const aspectRatio = width / height;
      const newWidth = Math.sqrt(maxSizeInBytes * aspectRatio);
      const newHeight = Math.sqrt(maxSizeInBytes / aspectRatio);
      canvas.width = newWidth;
      canvas.height = newHeight;
      
      // Clear canvas with transparent background
      ctx.clearRect(0, 0, newWidth, newHeight);
      
      // Draw image with high quality settings
      ctx.imageSmoothingEnabled = true;
      ctx.imageSmoothingQuality = 'high';
      ctx.drawImage(img, 0, 0, newWidth, newHeight);
      
      // Determine if the original image is PNG (likely has transparency)
      const isPNG = base64Image.indexOf('data:image/png') === 0;
      
      // Use PNG format if original was PNG to preserve transparency, otherwise use JPEG
      let dataURL;
      if (isPNG) {
        dataURL = canvas.toDataURL('image/png');
      } else {
        let quality = 0.8;
        dataURL = canvas.toDataURL('image/jpeg', quality);
      }
      
      resolve(dataURL);
    };
  });
}

/**
 * Converts a Sanity image object to a base64 string.
 * It first fetches the Sanity image URL and then converts it to a blob.
 * It then calls the convertBase64 function to convert the blob to a base64 string.
 *  #pictures
 * @param {object} sanityImage - The Sanity image object to be converted
 * @returns {Promise<string>} A Promise that resolves to the base64 string
 */
export const fromSanityPicToBase64 = async (sanityImage) => {

  const sanityImageUrl = urlFor(sanityImage).url()
  return fetch(sanityImageUrl)
  .then(response => response.blob())
  .then(async blob => {
    return convertBase64(blob)
    .then(base64=>base64)
  });
}

/**
 * #core
 * @param {*} latitude latitude First
 * @param {*} longitude longitude Second
 * @returns link to google maps
 */
export const gMapLink = (latitude,longitude) => {
  const long = longitude?.toString()?.replace(/,/g, '.')
  const lat = latitude?.toString()?.replace(/,/g, '.')
  //console.log("LINK GM", long, lat)
  return(`https://www.google.com/maps/search/?api=1&query=${long},${lat}`)
}

/**
 * #core
 * Returns a link to Google Maps for a given address.
 * The address is URL encoded and passed as a query parameter.
 * @param {string} address - The address to search for on Google Maps
 * @returns {string} A link to Google Maps with the address as a query parameter
 */
export const gMapAddressLink = (address) => {

  //console.log("LINK GM", long, lat)
  return(`https://www.google.com/maps/search/?api=1&query=${address}`)
}

/**
 * Returns a string representing the site name.
 * The format is "PLESSO <siteNumber>: <label>".
 * #anagraficheManagement
 * @param {object} site - The site object to get the name from
 * @returns {string} A string representing the site name
 */
export const siteName = (site) => 
  `PLESSO ${site?.siteNumber}: ${site?.label}`

/**
 * Returns a string representing the site name with underscores instead of spaces.
 * The format is "PLESSO_<siteNumber>_<label>".
 * #anagraficheManagement
 * @param {object} site - The site object to get the name from
 * @returns {string} A string representing the site name with underscores instead of spaces
 */
export const siteNameString = (site) => 
  `PLESSO_${site?.siteNumber}_${site?.label}`

/**
 * Returns a string combining the label and name.
 * The format is "<label> <name>".
 * #registers
 * @param {string} [label=""] - The label to combine with the name
 * @param {string} [name=""] - The name to combine with the label
 * @returns {string} A string combining the label and name
 */
export const labelAndName = (label="", name="") => {
  return `${label} ${name}`
}

/**
 * Returns the position number of a device.
 * The position number is a value associated with a template field of id "5710d994-8bc9-4981-a5af-94a535d27bbd".
 * It is used to represent the position of a device in a site.
 * #devicesFields
 * @param {object} device - The device object to get the position number from
 * @returns {string} The position number of the device
 */
export const positionNumber = (device) => {
  const positionId = "5710d994-8bc9-4981-a5af-94a535d27bbd"
  return matchTemplateFieldWithValue(positionId, device?.locations)?.value
} 
/**
 * Returns the floor number of a device.
 * The floor number is a value associated with a template field of id "100089e6-e85d-467f-92b2-958628470ea2".
 * It is used to represent the floor of a device in a site.
 * #devicesFields
 * @param {object} device - The device object to get the floor number from
 * @returns {string} The floor number of the device
 */
export const floor = (device) => {
  const floorId = "100089e6-e85d-467f-92b2-958628470ea2"
  return matchTemplateFieldWithValue(floorId, device?.locations)?.value
} 

/**
 * Merges the zone and area fields of a device.
 * If the device has a zone field and an area field, it will merge the values of the two fields.
 * If the device only has a zone field, it will create a new area field with the values of the zone field.
 * If the device only has an area field, it will not modify the device.
 * #devicesFields
 * @param {object} device - The device object to merge the zone and area fields of
 * @returns {array} The locations array with the zone and area fields merged
 */
export const mergeZone = (device) => {    
  const zoneId = "d770ea67-ef56-404d-a7be-37f18f6ea8be"
  const areaId = "2e587bd1-e26e-4938-9c26-d7c16199ffe6"

  const zoneField = !Array.isArray(device?.locations) ? {} : device?.locations?.find?.((x)=>x?.templateField?._ref == zoneId) 
  const areaField = !Array.isArray(device?.locations) ? {} : device?.locations?.find?.((x)=>x?.templateField?._ref == areaId)

  if(zoneField?.values?.[0]?.label && areaField?.values?.[0]?.label){
      const filteredArray = !Array.isArray(device?.locations) ? [] : device?.locations?.filter?.(x=>x?.templateField?._ref !== zoneId && x?.templateField?._ref !== areaId)
      const updatedArray = [...filteredArray, {...areaField, values:[...areaField?.values, ...zoneField?.values]}]
      return updatedArray
  }
  if(zoneField?.values?.[0]?.label && !areaField?.label){
      const filteredArray = !Array.isArray(device?.locations) ? [] : device?.locations?.filter?.(x=>x?.templateField?._ref !== zoneId)
      const updatedArray = [...filteredArray, {templateField:{_ref: areaId, _type: "reference"}, values:[...zoneField?.values]}]
      return updatedArray
  }
  
  return device?.locations
}
/**
 * Returns the area of a device.
 * The area is a value associated with a template field of id "2e587bd1-e26e-4938-9c26-d7c16199ffe6".
 * It is used to represent the area of a device in a site.
 * #devicesFields
 * @param {object} device - The device object to get the area from
 * @returns {string} The area of the device
 */
export const deviceAreas = (device) => 
  {
    const areaId = "2e587bd1-e26e-4938-9c26-d7c16199ffe6"
    return matchTemplateFieldWithValue(areaId, mergeZone(device))?.value
  } 

/**
 * Checks if a device with the given id is present in a register.
 * #devices
 * @param {string} deviceId - The id of the device to look for
 * @param {object} register - The register object to search in
 * @returns {object|null} The device object if found, null otherwise
 */
export const deviceInRegister = (deviceId, register) => {
  const findDevice = !Array.isArray(register?.devices) ? [] : register?.devices?.find?.(x=>x?._id == deviceId)
  return findDevice
}

/**
 * Checks if the sum of all the numbers in an array is zero.
 * #offerTotals
 * #offers
 * @param {array} arr The array to check.
 * @returns {boolean} True if the sum is zero, false otherwise.
 */
export const isSumZero = (arr) => {
  const sum = arr.reduce((acc, val) => {
    return typeof val === 'number' ? acc + val : acc;
  }, 0);

  return sum === 0;
};

/**
 * Formats a number as a euro value.
 * #core #offers
 * @param {number} num - The number to format as a euro value
 * @returns {string} The formatted number as a euro value
 */
export const euro = (num) => Intl.NumberFormat("de-DE", {
  style: 'currency',
  currency: 'EUR',
}).format(num);

//euro(num)

/**
 * Formats a number as a decimal value with up to two decimal places.
 * #core #offers
 * @param {number} num - The number to format as a decimal value
 * @returns {string} The formatted number as a decimal value
 */
export const twoDecimals = (num) => Intl.NumberFormat("de-DE", {
  style: 'decimal',
  minimumFractionDigits: 0,
  maximumFractionDigits: 2,
}).format(num);

/**
 * Formats a number as a decimal value with no decimal places.
 * #core #offers
 * @param {number} num - The number to format as a decimal value
 * @returns {string} The formatted number as a decimal value
 */
export const noDecimals = (num) => Intl.NumberFormat("de-DE", {
  style: 'decimal',
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
}).format(num);

//twoDecimals(num)

/**
 * Formats a number as a percentage value with two decimal places.
 * #core #offers
 * @param {number} num - The number to format as a percentage value
 * @returns {string} The formatted number as a percentage value
 */
export const percentage = (num) => Intl.NumberFormat("de-DE", {
  style: 'percent',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
}).format(num / 100);
//percentage(num)

/**
 * Formats a number according to a given number format.
 * #core #offers
 * @param {number|string} value - The value to format
 * @param {string} numberFormat - The number format to use. Can be "euro", "percentage", or "twoDecimals".
 * @returns {string} The formatted number
 */
export const formattedNumber = (value, numberFormat) => {
  const dataNumber = Number(value) ? Number(value) : 0
  //if (!dataNumber) return 0
  if(numberFormat == "euro"){return euro(dataNumber)}
  if(numberFormat == "percentage"){return percentage(dataNumber)}
  if(numberFormat == "twoDecimals"){return twoDecimals(dataNumber)}
  return twoDecimals(dataNumber)
}

/**
 * Returns an object containing the total price to the client, the total profit, the total cost and the margin of the offer.
 * #offerTotals
 * @param {array} offerData - An array of customer products
 * @param {array} allOffers - An array of all offers
 * @returns {object} An object containing the total price to the client, the total profit, the total cost and the margin of the offer
 */
export const offerTotals = (offerData=[], allOffers=[]) => {
  //ACCOMODATES LABOUR HOURS AND UNITS
  //#showHideOffer
  //#showHideOrder
  //#offerTotals
  const value = (customerProduct, valueType) => {
    //const isLabourProduct = customerProduct?.labourProduct
    //if(isLabourProduct && customerProduct?.customerProductId == "feb2d300-8e54-4f42-ba64-b92da9c1256c" ) console.log("lakaslkdkjsalkdjaldkj", customerProduct)
    
    // Handle undefined or null valueType
    if (valueType === undefined || valueType === null || valueType === '') return 0
    
    const numericValueType = Number(valueType)
    const numericUnit = Number(customerProduct?.unit)
    
    // Handle NaN cases
    if (isNaN(numericValueType)) return 0
    if (isNaN(numericUnit) || numericUnit <= 0) return numericValueType
    
    return numericValueType * numericUnit
    }
  const data = (Array.isArray(offerData) && Array.isArray(allOffers) && allOffers?.lengths > 0 ) ? HiddenOfferData({offerData, allOffers}) 
    : Array.isArray(offerData) ? offerData : []
  
  const safeReduce = (mappedValues) => {
    return mappedValues?.reduce((partialSum, a) => {
      const numA = Number(a)
      const numSum = Number(partialSum)
      // Only add if both are valid numbers
      if (isNaN(numA)) return numSum
      if (isNaN(numSum)) return numA
      return numSum + numA
    }, 0) || 0
  }
  
  const priceToClient = !Array.isArray(data) ? 0 : safeReduce(
    data?.filter?.((x)=>!x?.hide)?.map?.((x)=>value(x, x?.priceToClient))
  )
  
  const profit = !Array.isArray(data) ? 0 : safeReduce(
    data?.filter?.((x)=>!x?.hide)?.map?.((x)=>value(x, x?.profit))
  )
  
  const cost = !Array.isArray(data) ? 0 : safeReduce(
    data?.filter?.((x)=>!x?.hide)?.map?.((x)=>value(x, x?.totalCost))
  )
  
  //#margin
  //const margin = (+profit/+cost) * 100
  const margin = priceToClient > 0 ? (profit / priceToClient) * 100 : 0
  //const margin = (+profit * 100)/+priceToClient
  const doc = {priceToClient, profit, margin, cost}
  //console.log("hnwjkndewkjdnh",priceToClient)
  return doc
}

/**
 * Formats an offer totals object.
 * #offerTotals
 * @param {object} offerTotals - An object containing the total price to the client, the total profit, the total cost and the margin of the offer
 * @returns {object} An object containing the formatted total price to the client, the formatted total profit, the formatted total cost and the formatted margin of the offer
 */
export const offerTotalsFormatted = (offerTotals) => {
  //#offerTotals
  if(!offerTotals) return {}
  const priceToClient = euro(Number(offerTotals?.priceToClient || 0))
  const profit = euro(Number(offerTotals?.profit || 0))
  const margin = percentage(Number(offerTotals?.margin || 0))
  const cost = euro(Number(offerTotals?.cost || 0))

/**
 * Returns the color of the margin depending on its value.
 * - Red if the margin is less than 5
 * - Amber if the margin is less than 25
 * - Green otherwise
 * #core
 * @returns {string} The color of the margin
 */
  const marginColor = () => {
    if(offerTotals?.margin < 5 ) return "red"
    if(offerTotals?.margin < 25 ) return "amber"
    return "green"
   }


  const doc = {priceToClient, profit, margin, cost, marginColor: marginColor() }

  return doc

 }

/**
 * Generates a 4-digit token.
 * #core #login
 * @returns {number} A 4-digit token
 */
 export const fourDigitsToken = () => {
  const randomNum = Math.random() * 9000
  const token = Math.floor(1000 + randomNum)
  return token


}

/**
 * Slugify a string, making it suitable for use as a URL slug.
 * Removes accents, whitespace, and non-alphanumeric characters, and
 * converts to lowercase. If addToken is true, appends a 4-digit
 * token to the end of the slug.
 * #core
 * @param {string} str The string to slugify
 * @param {boolean} addToken Whether to append a 4-digit token to the end of the slug
 * @returns {string} The slugified string
 */
 export const slugify = (str, addToken=false) => {
  const string = String(str)
  .normalize('NFKD') // split accented characters into their base characters and diacritical marks
  .replace(/[\u0300-\u036f]/g, '') // remove all the accents, which happen to be all in the \u03xx UNICODE block.
  .trim() // trim leading or trailing whitespace
  .toLowerCase() // convert to lowercase
  .replace(/[^a-z0-9 -]/g, '') // remove non-alphanumeric characters
  .replace(/\s+/g, '-') // replace spaces with hyphens
  .replace(/-+/g, '-'); // remove consecutive hyphens
  if(addToken) return string+fourDigitsToken()
  return string
}

/**
 * Returns a full address string for a given site object.
 * The address string is generated by concatenating the address1, address2, houseNumber, postCode, city and province fields of the site object.
 * If any of the fields are not present in the site object, an empty string is used in its place.
 * #anagraficheManagement
 * @param {Object} site The site object from which to generate the address string
 * @returns {string} The full address string
 */
export const siteAddress = (site) => {
  const address = {
      houseNumber: site?.houseNumber ? `${site?.houseNumber},` : "",
      line1: site?.address1 ? `${site?.address1},` : "",
      line2: site?.address2 ? `${site?.address2},` : "",
      city: site?.city ? site?.city : "",
      postCode: site?.postCode ? `${site?.postCode},` : "", 
      province: site?.province ? `(${site?.province})` : "",   
  }
  const {houseNumber, line1, line2, city, postCode, province} = address
  const fullAddress = `${line1} ${houseNumber} ${line2} ${postCode} ${city} ${province} `
  return fullAddress
}

/**
 * Filters out objects with a status of "COMPLETATO" or "ARCHIVIATO".
 * #deviceNonConformities
 * @param {Object} x The object to filter
 * @returns {boolean} True if the object passes the filter, false otherwise
 */
export const filterActiveStatus = (x) => 
  x?.status!=="COMPLETATO" && x?.status!=="ARCHIVIATO"

/**
 * Adds the order property to the given register object from the template.
 * #registers
 * @param {Object} register The register object to add the order to
 * @param {Object} template The template object from which to get the order
 * @returns {Object} The updated register with the order property
 */
export const addOrderToRegister = (register, template) => {
  const updatedOrder = {...register, order: template?.order}
return updatedOrder
}

/**
 * Filters out labour products with ids "d0b3f302-92ef-423b-bd9f-709c35e6dde2" and "34a1fc10-375b-4238-bd37-3a339a70243a".
 * #offers #labourProducts
 * @param {Object} x The object to filter
 * @returns {boolean} True if the object passes the filter, false otherwise
 */
export const filterLabourProducts = (x) => 
  x?._id !== "d0b3f302-92ef-423b-bd9f-709c35e6dde2" && x?._id !== "34a1fc10-375b-4238-bd37-3a339a70243a"

/**
 * Analyzes the user logs for a given array of devices and returns a sorted array of log analysis objects.
 * Each log analysis object contains the date of the log, the log object itself, the time in seconds between the current log and the previous log, the time in minutes and seconds between the current log and the previous log, and the decimal time in minutes between the current log and the previous log.
 * #reports #historyLogs
 * @param {Array} devices The array of devices to analyze the user logs for
 * @param {string} registerId The register id to filter the devices by
 * @returns {Array} A sorted array of log analysis objects
 */
export const logAnalysis = (devices, registerId) => {

  const checks = devices
      ?.filter?.(x=>{
        if(registerId) return x?.register?._ref == registerId
        return x})
      ?.map?.((x)=>{
        const lastCheck = userLogCheck(x)
        return lastCheck})
      ?.sort(sortByDate)
  
  const dates = checks?.map?.((item, i, array)=>{
      const date = new Date(item?.date)?.toString();

      const secondsBetweenDates = (array[i]?.date - array[i-1]?.date)/1000

      const decimalTimeString = (array[i]?.date - array[i-1]?.date)/60000
      var n = new Date(0,0);
      n.setSeconds(+decimalTimeString * 60 * 60);
      const minAndSec = n.toTimeString().slice(0, 8);

      const doc = {date, check:item, seconds: secondsBetweenDates, minutes: minAndSec, decimalMinutes: decimalTimeString}
      return doc
  })

  console.log("==========LOG ANALYSYS ==========", dates)
  
  return dates
}

/**
 * Shows a yes/no alert to the user with the given alert text.
 * If the user clicks "SI", the given function is called.
 * #core
 * @param {Function} fn The function to call if the user clicks "SI"
 * @param {string} alertText The text to display in the alert
 */
export const yesNoAlert = (fn, alertText) => {

  Swal.fire({
      title: alertText,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: "SI'",
      cancelButtonText: "NO",
    }).then((result) => {
      if (result.isConfirmed) {
          fn()
      }
    })
}

/**
 * Checks if the given customer product is included in the maintenance tasks of the given client
 * #deadlines
 * @param {Object} client The client object
 * @param {Object} customerProduct The customer product object
 * @param {Object} nonConformity The non conformity object
 * @returns {boolean} True if the customer product is included in the maintenance tasks, false otherwise
 */
export const isMaintenanceIncluded = (client, customerProduct, nonConformity) => {

  const isProductIncludedInTender = client?.customerProductsIncludedInTender?.some?.((x)=>x?._ref == customerProduct?._id)
  const isProductMaintenance = customerProduct?.maintenanceTask
  const isRegisterIncluded = customerProduct?.registers?.some?.((x)=>client?.maintenanceTasksIncluded?.some?.((y)=>y?._ref == x?._ref))
  const excludeMaintenanceProducts = [
    "5f577ef3-7252-4f0b-a314-17f22af0afe5", // COLLAUDO QUINQUENNALE UNI 25
    "11b2e335-6833-4978-8727-7fee160d0646", // COLLAUDO QUINQUENNALE
  ]
  const isHidden = excludeMaintenanceProducts?.some?.((x)=>x == customerProduct?._id)
  
  if(isProductIncludedInTender) return true
  if(isHidden) return false
  if(isProductMaintenance && isRegisterIncluded) return true
  if(isRegisterIncluded && nonConformity?.label == "REVISIONARE") return true
  if(isRegisterIncluded && nonConformity?.label == "COLLAUDARE") return true
  return false
}

/**
 * Returns an array of objects containing the years from the first year to the current year plus yearsBeyondCurrent.
 * Each object in the array contains the year as a string in the "label" and "value" properties, 
 * as well as an "_id", "_key", and "_type" property.
 * The array is sorted in descending order by the year.
 * #deviceFields
 * @param {number} yearsBeyondCurrent - The number of years beyond the current year to include in the array
 * @param {number} firstYear - The first year to include in the array
 * @returns {Array<Object>} - An array of objects containing the years
 */
export const yearsList = (yearsBeyondCurrent = 0, firstYear = 1990) => {
  //const firstYear = 1990
  let years = []
  const currentYear = new Date().getFullYear()
  for (let i = firstYear; i <= currentYear + yearsBeyondCurrent; i++){
    years?.push(i)
  }
  return years?.map?.((x)=>({label: x?.toString(), value: x?.toString(), _id: uuidv4(), _key: keyId(), _type: "deviceProperty"}))?.sort(sortByLabelDesc)
}

/**
 * Returns an array of objects containing the months from 1 to 12.
 * Each object in the array contains the month as a string in the "label" and "value" properties, 
 * as well as an "_id", "_key", and "_type" property.
 * The array is not sorted.
 * #deviceFields
 * @returns {Array<Object>} - An array of objects containing the months
 */
export const monthsList = () => {

  return [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]?.map?.((x)=>({label: x?.toString(), value: x?.toString(), _id: uuidv4(), _key: keyId(), _type: "deviceProperty"}))
}

/**
 * Produces a function which uses template strings to do simple interpolation from objects.
 * #richText
 * Usage:
 *    var makeMeKing = generateTemplateString('${name} is now the king of ${country}!');
 *    
 *    console.log(makeMeKing({ name: 'Bryan', country: 'Scotland'}));
 *    // Logs 'Bryan is now the king of Scotland!'
 */
export const generateTemplateString = (function(){
  var cache = {};

  function generateTemplate(template){
      var fn = cache[template];

      if (!fn){
          // Replace ${expressions} (etc) with ${map.expressions}.

          var sanitized = template
              .replace(/\$\{([\s]*[^;\s\{]+[\s]*)\}/g, function(_, match){
                  return `\$\{map.${match.trim()}\}`;
                  })
              // Afterwards, replace anything that's not ${map.expressions}' (etc) with a blank string.
              .replace(/(\$\{(?!map\.)[^}]+\})/g, '');

          fn = Function('map', `return \`${sanitized}\``);
      }

      return fn;
  }

  return generateTemplate;
})();

/**
 * Converts a rich editor document to a new document with dynamic values replaced in the text of each block.
 * #richText
 * @param {Object} richEditorDocument - The rich editor document to convert.
 * @param {Object} dynamicData - An object containing the dynamic values to replace in the text of each block.
 * @returns {Array<Object>} - An array of objects containing the converted blocks.
 */
export const convertRichEditorDynamicData = (richEditorDocument, dynamicData) => { 

  const richDocWithDynamicValues = richEditorDocument?.blocks?.map?.((block)=>{
      const text = block?.text ? block?.text : ""
      const convertText = generateTemplateString(text)
      const newBlock = {...block, text: convertText(dynamicData)}
      return newBlock
  })
  return richDocWithDynamicValues
  }

/**
 * Converts a comma-separated string to an array of strings.
 * Trims each string in the resulting array.
 * #core
 * @param {string} string - The comma-separated string to convert.
 * @returns {Array<string>} - An array of strings.
 */
 export const commaSeparatedStringToArray = (string) => {
    return string?.split(',')?.map?.((x)=>x?.trim())
 }

/**
 * Calculates the discounted price of a product based on the price and discount percentage.
 * #offers
 * @param {number} price - The price of the product.
 * @param {number} discount - The discount percentage.
 * @returns {string} The discounted price of the product, rounded to two decimal places.
 */
 export const discountedPrice = (price, discount) => 
  price - (price * discount / 100 )?.toFixed(2)

/**
 * Returns an object containing the non-conformity maintenance tasks to be
 * performed for the given device and register template, as well as the
 * deadlines for the given device.
 * Theese are the fields of type "dataModule" that include the non conformity to generate if the deadline is passed
 * #deadlines
 * @param {Object} device - The device object
 * @param {Object} registerTemplate - The register template object
 * @param {string} sUser - The user id of the user that is performing the operation
 * @returns {Object} result - An object containing the deadlines and maintenance tasks
 */
 export  const deadlinesData = (device, registerTemplate, sUser) => {
  const deadLine = deadlines(device, registerTemplate)?.checkData?.maintenanceTasksList
  if(deadLine?.length>0) {
      const deadlineDoc = {
          nonConformityId: deadLine[0]?._id,
          deadLine,
          firstDeadline: {...deadLine[0], device}
      }
      return {...deviceNonConformityDoc(deadLine[0]?._id, sUser), device, _id: deviceAndNonConfId(device?._id, deadLine[0]?._id)}
  }
}
/**
 * Returns an object containing the non-conformity maintenance tasks to be
 * performed for the given device and register template, as well as the
 * deadlines for the given device, with the custom year as the current year.
 * Theese are the fields of type "dataModule" that include the non conformity to generate if the deadline is passed
 * #deadlines
 * @param {Object} device - The device object
 * @param {Object} registerTemplate - The register template object
 * @param {string} sUser - The user id of the user that is performing the operation
 * @param {number} customYear - The custom year to check for deadlines
 * @returns {Object} result - An object containing the deadlines and maintenance tasks
 */
 export  const futureDeadlinesData = (device, registerTemplate, sUser, customYear) => {
  const deadLine = deadlines(device, registerTemplate, customYear)?.checkData?.maintenanceTasksList
  const allDeadlines = deadlines(device, registerTemplate, customYear)
  if(deadLine?.length>0) {
      const deadlineDoc = {
          nonConformityId: deadLine[0]?._id,
          deadLine,
          customYear,
          allDeadlines,
          deviceNonConformity: {...deviceNonConformityDoc(deadLine[0]?._id, sUser), device, _id: deviceAndNonConfId(device?._id, deadLine[0]?._id)},
          firstDeadline: {...deadLine[0], device}
      }
      return {...deviceNonConformityDoc(deadLine[0]?._id, sUser), device, _id: deviceAndNonConfId(device?._id, deadLine[0]?._id)}
      
  }
}

/**
 * Copies the _id of the given document to the clipboard.
 * #core
 * @param {Object} doc - The document containing the _id property to copy.
 */
export const copyId = (doc) => {
  return navigator.clipboard.writeText(doc?._id);
}

/**
 * Merges two arrays of objects based on their _id property, with array2 values taking precedence when there's a match.
 * If array1 is not an array, returns an empty array. For each item in array1, if a matching _id is found in array2,
 * uses the array2 item, otherwise keeps the array1 item.
 * #orders #unused
 * @param {Array} array1 - The base array of objects, each containing an _id property
 * @param {Array} array2 - The array to merge with, its matching items will override array1 items
 * @returns {Array} A new array containing merged items from both arrays, with array2 values taking precedence
 */
export const mergeArraysById = (array1, array2) => {  
  const array1Checked = !Array.isArray(array1) ? [] : array1
  const array2Checked = !Array.isArray(array2) ? [] : array2
  return array1Checked.map?.((item)=>{
    const findField = array2Checked?.find?.((x)=>x?._id == item?._id)
    if(findField){
      return findField
    }
    return item
})
}

/**
 * Returns an empty object if the given object is not of type "object" or is null,
 * otherwise returns the object itself.
 * #core
 * @param {Object} obj - The object to check
 * @returns {Object} The object itself or an empty object
 */
export const objectIsObject = (obj) => {
  return typeof obj !== "object" || obj === null ? {} : obj
}

/**
 * Checks if there is at least one base64 image in the given register.
 * It iterates through all devices and their comments, and then through
 * all images in each comment. If it finds a base64 image, it immediately
 * returns true. If it doesn't find any, it returns false.
 * #pictures
 * @param {Object} register - The register to check
 * @returns {Boolean} True if there is at least one base64 image, false otherwise
 */
export const isThereBase64 = (register) => {
  if(!register) return false
  if(!register?.devices) return false
  if(!register?.devices?.length) return false
  const devices = register?.devices
  const checks = devices?.map((device)=> {
    if(!device?.comments) return false
    if(!device?.comments?.length) return false
    const comments = device?.comments
    const images = comments?.map((comment)=>{
      if(!comment?.images) return false
      if(!comment?.images?.length) return false
      const base64s = comment?.images?.map((image)=>{
        if(image?.before?.base64Image) return true
        if(image?.after?.base64Image) return true
        return false
      })
      if(base64s?.some((x)=>x == true)) return true
      return false
    })
    if(images?.some((x)=>x == true)) return true
    return false
  })
  if(checks?.some((x)=>x == true)) return true
  return false
}

/**
 * Returns an html string representing an info line.
 * If the given value is falsey (i.e. null, undefined, empty string), it returns an empty string.
 * Otherwise, it returns a div containing a p tag with strong text representing the title, and the value.
 * #offers
 * @param {Object} {value, title} - The value and title to display
 * 
 * @returns {String} The html string representing the info line
 */
  export const htmlInfoLine = ({value, title}) => {
      if(!value) return ""
      return `
        <div style="display: flex">
          <p><strong>${title}:</strong> ${value}</p>
      </div>
      `
  }

/**
 * Generates an id string based on the given device id, non conformity id, and an optional suffix.
 * If either the device id or non conformity id is falsy, returns a uuidv4 string.
 * If a suffix is provided, returns a string in the format of "${deviceId}_${nonConformityId}_${suffix}".
 * Otherwise, returns a string in the format of "${deviceId}_${nonConformityId}_${shortId()}".
 * #offers
 * @param {string} deviceId - The id of the device
 * @param {string}nonConformityId - The id of the non conformity
 * @param {string} [suffix] - An optional suffix to append to the generated id
 * @returns {string} The generated id string
 */
  export const deviceAndNonConfId = (deviceId, nonConformityId, suffix) => {
    if(!deviceId || !nonConformityId) return uuidv4()
    if(suffix) return `${deviceId}_${nonConformityId}_${suffix}`
    return `${deviceId}_${nonConformityId}_${shortId()}`
  }

/**
 * Finds duplicate keys in an array of objects.
 * Returns an array of arrays, where each sub array contains objects with duplicate keys.
 * If the trueFalse parameter is true, returns a boolean indicating whether any duplicate keys were found.
 * #registerManagement
 * @param {Object} {arrayToCheck=[], trueFalse=false} - options object containing the array to check and a boolean indicating whether to return a boolean instead of an array
 * @returns {Array<Array<Object>> | boolean} - an array of arrays of objects with duplicate keys, or a boolean indicating whether any duplicate keys were found
 */
    export const findDuplicateKeys = ({arrayToCheck=[], trueFalse}) =>{
        
        const array = !Array.isArray(arrayToCheck) ? [] : arrayToCheck
        const dataWithUniqueKeys = unique("_key", array)
        const modifyUniqueKeys = dataWithUniqueKeys?.map((item, index, originalArray)=>{
            const foundKeys = originalArray?.filter?.((x)=>x?._key == item?._key)
            if(foundKeys?.length > 1){
                return foundKeys
            }
            return 
        })?.filter?.((x)=>x)
        if(trueFalse) return modifyUniqueKeys?.length > 0 ? true : false
        //console.log(" opqwdkqpodkqpowkd", {modifyUniqueKeys, array})
        return modifyUniqueKeys

    }

/**
 * Checks if a given timestamp is today.
 * #login
 * Compares the date part of the given timestamp (ignoring the time) with the current date.
 * @param {number} timestamp - The timestamp to check
 * @returns {boolean} True if the timestamp is today, false otherwise
 */
export const isToday = (timestamp) => {
  const date = new Date(timestamp); // convert ms to Date
  const today = new Date();

  return (
    date.getDate() === today.getDate() &&
    date.getMonth() === today.getMonth() &&
    date.getFullYear() === today.getFullYear()
  );
}
